<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <welcomecard />
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="card">
      <div v-if="this.is_authorization === null" class="card-body">
        <div class="d-flex justify-content-center">
          authorization checking...
        </div>
      </div>
      <div v-if="this.is_authorization === 'N'" class="card-body">
        <div class="d-flex justify-content-center">
          You do not have authorization for this page
        </div>
      </div>
      <div v-if="this.is_authorization=== 'Y'" class="card-body">

        <div v-if="this.eventDetails.payment_method === 'DIRECT'" class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <h5 style="padding: 15px;">{{this.eventDetails.title }}</h5>
              <div class="header-top">
                <h5 class="m-0"></h5>
                <form class="form-inline">
                  <div class="form-group">
                    <select class="form-select" v-model="order_filter_type">
                      <option value="mobile">หมายเลขโทรศัพท์</option>
                      <option value="uuid">เลขที่ใบสมัคร (OrderNo)</option>
                      <option value="status">สถานะ</option>
                      <option value="email">อีเมลล์</option>
                      <option value="delivery_add_name">ชื่อผู้สมัคร</option>
                      <option value="runner_json">ชื่อผู้สมัคร หรือสมาชิกในคำสั่งซื้อเดียวกัน</option>
                      <option value="order_deleted" >คำสั่งซื้อที่ลบไปแล้ว</option>
                      
                    </select>
                  </div>
                  &nbsp;
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="order_filter_value"
                      type="text"
                      minlength="3"
                      placeholder="คำค้นหา"
                    />
                  </div>
                  &nbsp;&nbsp;
                  <button
                    type="submit"
                    @click.prevent="load_last_registration('')"
                    @submit.prevent="load_last_registration('')"
                    class="btn btn-primary px-2 py-1 text-sm"
                  >
                    <vue-feather type="filter" size="18"> </vue-feather>
                    ค้นหา</button
                  >&nbsp;&nbsp;
                  <button
                    type="reset"
                    @click.prevent="load_last_registration('INITIAL_HAVE_SLIP')"
                    class="btn btn-primary px-2 py-1 text-sm"
                  >
                    <vue-feather type="bookmark" size="18"> </vue-feather>
                    รายการรอชำระที่แนบหลักฐานแล้ว
                  </button>&nbsp;&nbsp;
                  <button
                    type="reset"
                    @click.prevent="clearLatestOrder()"
                    class="btn btn-primary px-2 py-1 text-sm"
                  >
                    <vue-feather type="refresh-cw" size="18"> </vue-feather>
                    ทั้งหมด
                  </button>
                </form>
              </div>
            </div>
            <div v-if="total_records > 0" class="d-flex justify-content-end p-2">
              <nav>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: current_page === 1 }">
                    <button type="button" class="page-link" @click.prevent="go_to_page(current_page - 1)">‹</button>
                  </li>
                  <template v-for="(p, idx) in getPaginationPages()" :key="idx">
                    <li v-if="p === '...'" class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>
                    <li v-else class="page-item" :class="{ active: p === current_page }">
                      <button type="button" class="page-link" @click.prevent="go_to_page(p)">{{ p }}</button>
                    </li>
                  </template>
                  <li class="page-item" :class="{ disabled: current_page === total_pages }">
                    <button type="button" class="page-link" @click.prevent="go_to_page(current_page + 1)">›</button>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ใบสมัคร</th>
                    <th style="text-align: center">สถานะ</th>
                    <th style="text-align: center">วันที่สมัคร</th>
                    <th style="text-align: center">ใบเสร็จ</th>
                    <th style="text-align: center">รับเงินเข้าระบบ</th>
                    <th style="text-align: center">ยอดเงิน</th>
                    <th style="text-align: center">เวลาที่โอนเงิน</th>
                    <th style="text-align: center">หมายเลขบัตร</th>
                    <th style="text-align: center">หมายเลขโทรศัพท์</th>
                    <th style="text-align: center">ชื่อผู้สมัคร</th>
                    	
                    <th style="text-align: left">อีเมลล์</th>
                    <th style="text-align: left">จำนวนผู้สมัคร</th>
                    <th style="text-align: left">การจัดส่ง</th>
                    <th style="text-align: left">แก้ไขข้อมูล</th>
                    <th style="text-align: left">ลบ</th>
                    
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_last_registration === 'Y'">
                  <tr>
                    <td colspan="15">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                
                <tbody v-if="this.report_last_registration.length !== 0">
                  <tr v-for="item in this.report_last_registration" :key="item">
                    <td style="text-align: center"><a target="_blank" :href=" '/order/' + item.uuid"><u><b>{{ item.uuid }}</b></u></a></td>
                    <td v-if="item.status === 'INITIAL'">
                        <vue-feather type="clock" size="18" style="color: #ff9800; vertical-align: middle;"></vue-feather>
                        <font style="color: #ff9800; margin-left: 8px;">รอชำระเงิน</font>
                      </td>
                      <td v-if="item.status === 'PAID'">
                        <vue-feather type="check-circle" size="18" style="color: #28a745; vertical-align: middle;"></vue-feather>
                        <font style="color: #28a745; margin-left: 8px;">ชำระเงินสำเร็จ</font>
                      </td>
                      <td v-if="item.status === 'DELETE'">
                        <vue-feather type="trash-2" size="18" style="color: gray; vertical-align: middle;"></vue-feather>
                        <font style="color: gray; margin-left: 8px;">ถูกลบแล้ว</font>
                      </td>

                    <td style="text-align: center">{{ item.create_date }}</td>
                    <td style="text-align: center"><img :src=item.payment_slip_url style="width: 100px;" ></td>
                    <td v-if="item.status === 'INITIAL'" style="text-align: center"><button style="padding: 5px;" type="button" @click.prevent="direct_notify(item.uuid, item.mobile,item.id_card)" class="btn btn-primary" >
                              <vue-feather type="check-circle"  size="18"> </vue-feather> รับเงิน </button></td>
                    <td v-if="item.status === 'PAID'" style="text-align: center" ><vue-feather stroke="green" type="check-circle" size="20"> </vue-feather></td>  
                    <td v-if="item.status === 'DELETE'" style="text-align: center" >-</td>                            
                    <td style="text-align: center">{{ item.amount }}</td>
                    <td style="text-align: center">{{ item.payment_slip_time }}</td>
                    <td style="text-align: center">{{ item.id_card }}</td>
                    <td style="text-align: center">{{ item.mobile }}</td>
                    <td style="text-align: left">{{ item.delivery_add_name }}</td>
                    <td style="text-align: left">{{ item.email }}</td>
                    <td style="text-align: center">{{ item.runner_count }}</td>
                    <td style="text-align: left">{{ item.delivery_type_name }}</td>
                    <td style="text-align: left"><a target="_blank" :href=" '/order-update/' + this.eventDetails.event_key+'/'+item.uuid"><vue-feather type="edit" size="20"></vue-feather></a></td>
                    <td style="text-align: left"><button v-if="item.status === 'INITIAL'" type="button" @click.prevent="delete_order(item.uuid, item.mobile)" class="btn btn-danger" >ลบ</button><span v-if="item.status === 'DELETE'" >-</span></td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_last_registration.length === 0">
                  <tr>
                    <td colspan="15">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody>

                </tbody>
              </table>
            </div>
            <div v-if="total_records > 0" class="d-flex justify-content-between align-items-center flex-wrap gap-2 p-2">
              <small class="text-muted">ทั้งหมด {{ total_records }} รายการ (หน้า {{ current_page }} / {{ total_pages }})</small>
              <nav>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: current_page === 1 }">
                    <button type="button" class="page-link" @click.prevent="go_to_page(current_page - 1)">‹</button>
                  </li>
                  <template v-for="(p, idx) in getPaginationPages()" :key="idx">
                    <li v-if="p === '...'" class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>
                    <li v-else class="page-item" :class="{ active: p === current_page }">
                      <button type="button" class="page-link" @click.prevent="go_to_page(p)">{{ p }}</button>
                    </li>
                  </template>
                  <li class="page-item" :class="{ disabled: current_page === total_pages }">
                    <button type="button" class="page-link" @click.prevent="go_to_page(current_page + 1)">›</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        
        <div v-if="this.eventDetails.payment_method!= 'DIRECT'" class="col-xl-12">
          <div class="card">
            <h5 style="padding: 15px;">{{this.eventDetails.title }}</h5> 
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"></h5>
                <form class="form-inline">
                  <div class="form-group">
                    <select class="form-select" v-model="order_filter_type">
                      <option value="mobile">หมายเลขโทรศัพท์</option>
                       <option value="payment_ref">เลขที่อ้างอิง2 ของสลิปโอนเงิน(ref 2)</option>
                      <option value="uuid">เลขที่ใบสมัคร (OrderNo)</option>
                      <option value="status">สถานะ (รอชำระเงิน)</option>
                      <option value="email">อีเมลล์</option>
                      <option value="runner_json">ชื่อผู้สมัคร หรือสมาชิกในคำสั่งซื้อเดียวกัน</option>
                    </select>
                  </div>
                  &nbsp;
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="order_filter_value"
                      type="text"
                      minlength="3"
                      placeholder="คำค้นหา"
                    />
                  </div>
                  <span v-if="this.eventDetails.is_enable_refund === 'Y'">&nbsp;&nbsp;
                  <button
                    type="reset"
                    @click.prevent="load_last_registration('REFUND_REQUEST')"
                    class="btn btn-primary px-2 py-1 text-sm"
                  >
                    <vue-feather type="filter" size="18"> </vue-feather>
                    รายการขอคืนเงิน (รอโอน)
                  </button>
                  </span>
                  &nbsp;&nbsp;
                  <button
                    type="submit"
                    @click.prevent="load_last_registration('')"
                    @submit.prevent="load_last_registration('')"
                    class="btn btn-primary"
                  >
                    <vue-feather type="filter" size="18"> </vue-feather>
                    Filter</button
                  >&nbsp;&nbsp;
                  <button
                    type="reset"
                    @click.prevent="clearLatestOrder()"
                    class="btn btn-primary"
                  >
                    <vue-feather type="refresh-cw" size="18"> </vue-feather>
                    Refresh
                  </button>
                </form>
              </div>
            </div>
            <div v-if="total_records > 0" class="d-flex justify-content-end p-2">
              <nav>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: current_page === 1 }">
                    <button type="button" class="page-link" @click.prevent="go_to_page(current_page - 1)">‹</button>
                  </li>
                  <template v-for="(p, idx) in getPaginationPages()" :key="idx">
                    <li v-if="p === '...'" class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>
                    <li v-else class="page-item" :class="{ active: p === current_page }">
                      <button type="button" class="page-link" @click.prevent="go_to_page(p)">{{ p }}</button>
                    </li>
                  </template>
                  <li class="page-item" :class="{ disabled: current_page === total_pages }">
                    <button type="button" class="page-link" @click.prevent="go_to_page(current_page + 1)">›</button>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ใบสมัคร</th>
                    <th style="text-align: center">สถานะ</th>
                    <th style="text-align: center" v-if="this.eventDetails.is_enable_refund === 'Y'">สถานะ(การคืนเงิน)</th>
                    <th style="text-align: center">วันที่สมัคร</th>
                    <th style="text-align: center">จ่ายเงิน</th>
                    <th style="text-align: center">ยอดเงิน</th>
                    <th style="text-align: center">หมายเลขโทรศัพท์</th>
                    <th style="text-align: left">ชื่อผู้สมัคร</th>
                    <th style="text-align: left">อีเมลล์</th>
                    <th style="text-align: left">จำนวนผู้สมัคร</th>
                    <th style="text-align: left">การจัดส่ง</th>
                    <th style="text-align: left">แก้ไขข้อมูล</th>
                    <th style="text-align: left">ลบข้อมูล</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_last_registration === 'Y'">
                  <tr>
                    <td colspan="15">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_last_registration.length !== 0">
                  <tr v-for="item in this.report_last_registration" :key="item">
                    <td style="text-align: center"><a target="_blank" :href=" '/order/' + item.uuid"><u><b>{{ item.uuid }}</b></u></a></td>
                    <td v-if="item.status === 'INITIAL'">
                        <vue-feather type="clock" size="18" style="color: #ff9800; vertical-align: middle;"></vue-feather>
                        <font style="color: #ff9800; margin-left: 8px;">รอชำระเงิน</font>
                      </td>
                      <td v-if="item.status === 'PAID'">
                        <vue-feather type="check-circle" size="18" style="color: #28a745; vertical-align: middle;"></vue-feather>
                        <font style="color: #28a745; margin-left: 8px;">ชำระเงินสำเร็จ</font>
                      </td>
                    <td style="text-align: center" v-if="this.eventDetails.is_enable_refund === 'Y'">
                      <span v-if="item.refund_status === 'COMPLETED'" style="color: #28a745; font-weight: 500;">
                        <vue-feather type="check-circle" size="16" style="vertical-align: middle; margin-right: 4px;"></vue-feather>
                        COMPLETED
                      </span>
                      <span v-else-if="item.refund_status === 'REQUEST'" style="color: #ff9800; font-weight: 500;">
                        <vue-feather type="clock" size="16" style="vertical-align: middle; margin-right: 4px;"></vue-feather>
                        REQUEST
                      </span>
                      <span v-else>{{ item.refund_status }}</span>
                    </td>
                    <td style="text-align: left">{{ item.create_date }}</td>
                    <td style="text-align: center">{{ item.payment_date }}</td>
                    <td style="text-align: center">{{ item.amount }}</td>
                    <td style="text-align: center">{{ item.mobile }}</td>
                    <td style="text-align: left">{{ item.delivery_add_name }}</td>

                    <td style="text-align: left">{{ item.email }}</td>
                    <td style="text-align: center">{{ item.runner_count }}</td>
                    <td style="text-align: left">{{ item.delivery_type_name }}</td>
                    <td style="text-align: center"><a target="_blank" :href=" '/order-update/' + this.eventDetails.event_key+'/'+item.uuid"><vue-feather type="edit" size="20"></vue-feather></a></td>
                    <td style="text-align: left"><button v-if="item.status === 'INITIAL' || this.eventDetails.payment_method === 'FREE'" type="button" @click.prevent="delete_order(item.uuid, item.mobile)" class="btn btn-danger" >ลบ</button></td>
                  </tr>
                </tbody>
                <tbody>

                </tbody>
              </table>
            </div>
            <div v-if="total_records > 0" class="d-flex justify-content-between align-items-center flex-wrap gap-2 p-2">
              <small class="text-muted">ทั้งหมด {{ total_records }} รายการ (หน้า {{ current_page }} / {{ total_pages }})</small>
              <nav>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: current_page === 1 }">
                    <button type="button" class="page-link" @click.prevent="go_to_page(current_page - 1)">‹</button>
                  </li>
                  <template v-for="(p, idx) in getPaginationPages()" :key="idx">
                    <li v-if="p === '...'" class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>
                    <li v-else class="page-item" :class="{ active: p === current_page }">
                      <button type="button" class="page-link" @click.prevent="go_to_page(p)">{{ p }}</button>
                    </li>
                  </template>
                  <li class="page-item" :class="{ disabled: current_page === total_pages }">
                    <button type="button" class="page-link" @click.prevent="go_to_page(current_page + 1)">›</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>จำนวนผู้สมัคร แต่ละประเภท</b></h5>
                <div class="d-flex align-items-center gap-3">
                  <!-- View Toggle Buttons -->
                  <div class="btn-group" role="group" aria-label="View toggle">
                    <button type="button" 
                            @click="showChart = true" 
                            :class="['btn', 'btn-sm', showChart ? 'btn-primary' : 'btn-outline-primary']">
                      <vue-feather type="pie-chart" size="16"></vue-feather> กราฟ
                    </button>
                    <button type="button" 
                            @click="showChart = false" 
                            :class="['btn', 'btn-sm', !showChart ? 'btn-primary' : 'btn-outline-primary']">
                      <vue-feather type="grid" size="16"></vue-feather> ตาราง
                    </button>
                  </div>
                  <button type="button" @click.prevent="load_runner_type()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="refresh-cw" size="18"></vue-feather> Refresh
                  </button>
                  <!-- Export Chart Button (only show when chart view is active) -->
                  <button v-if="showChart" type="button" @click.prevent="exportChartAsImage()" 
                          :disabled="this.report_runner_type.length === 0"
                          class="btn btn-success px-2 py-1 text-sm">
                    <vue-feather type="download" size="18"></vue-feather> Export Chart
                  </button>
                </div>
              </div>
            </div>

            <!-- Chart View -->
            <div v-if="showChart && report_runner_type.length > 0 && is_loading_runner_type === 'N'" class="card-body px-2 py-3">
              <div class="row gx-2">
                <div class="col-md-8">
                  <div class="chart-container" style="position: relative; height: 368px; padding: 5px;">
                    <canvas ref="runnerTypeChart"></canvas>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="chart-legend">
                    <h6 class="mb-3"><b>รายละเอียด</b></h6>
                    <div v-for="(item, index) in this.report_runner_type" :key="index" class="legend-item mb-2">
                      <div class="d-flex align-items-center">
                        <div class="legend-color" :style="{ backgroundColor: getChartColor(index) }"></div>
                        <div class="legend-text">
                          <div class="legend-name" v-html="item.run_type_name"></div>
                          <div class="legend-count">{{ item.count_number }} คน</div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3 pt-3 border-top">
                      <div class="total-summary">
                        <strong>รวมทั้งหมด: {{ getTotalRunners() }} คน</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table View -->
            <div v-if="!showChart" class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">ประเภทการแข่งขัน</th>
                    <th style="text-align: center">จำนวนผู้สมัคร</th>
                    <th style="text-align: center">เปอร์เซ็นต์</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_runner_type === 'Y'">
                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_runner_type.length !== 0">
                  <tr v-for="item, index in this.report_runner_type" :key="item">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: left" v-html="item.run_type_name"></td>
                    <td style="text-align: center">{{ item.count_number }}</td>
                    <td style="text-align: center">{{ getPercentage(item.count_number) }}%</td>
                  </tr>
                  <!-- Total Row -->
                  <tr style="background-color: #f8f9fa; font-weight: bold; border-top: 2px solid #dee2e6;">
                    <td style="text-align: center">-</td>
                    <td style="text-align: left"><strong>รวม</strong></td>
                    <td style="text-align: center"><strong>{{ getTotalRunners() }}</strong></td>
                    <td style="text-align: center"><strong>100.0%</strong></td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_runner_type.length === 0">
                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Loading State -->
            <div v-if="is_loading_runner_type === 'Y'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center">
                  <img style="width: 60px" src="../../assets/images/running_loading.svg" />
                  <div class="mt-3">กำลังโหลดข้อมูล...</div>
                </div>
              </div>
            </div>

            <!-- No Data State -->
            <div v-if="report_runner_type.length === 0 && is_loading_runner_type === 'N'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center text-muted">
                  <vue-feather type="bar-chart" size="48" class="mb-3"></vue-feather>
                  <div>ไม่พบข้อมูลผู้สมัคร</div>
                </div>
              </div>
            </div>

            <!-- Loading State -->
            <div v-if="this.is_loading_runner_type === 'Y'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center">
                  <img style="width: 60px" src="../../assets/images/running_loading.svg" />
                  <div class="mt-3">กำลังโหลดข้อมูล...</div>
                </div>
              </div>
            </div>

            <!-- No Data State -->
            <div v-if="this.report_runner_type.length === 0 && this.is_loading_runner_type === 'N'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center text-muted">
                  <vue-feather type="bar-chart" size="48" class="mb-3"></vue-feather>
                  <div>ไม่พบข้อมูลผู้สมัคร</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>จำนวนผู้สมัคร แต่ละประเภท แบงตามเพศ</b></h5>
                <div class="d-flex align-items-center gap-3">
                  <!-- View Toggle Buttons -->
                  <div class="btn-group" role="group" aria-label="View toggle">
                    <button type="button" 
                            @click="showSexChart = true" 
                            :class="['btn', 'btn-sm', showSexChart ? 'btn-primary' : 'btn-outline-primary']">
                      <vue-feather type="pie-chart" size="16"></vue-feather> กราฟ
                    </button>
                    <button type="button" 
                            @click="showSexChart = false" 
                            :class="['btn', 'btn-sm', !showSexChart ? 'btn-primary' : 'btn-outline-primary']">
                      <vue-feather type="grid" size="16"></vue-feather> ตาราง
                    </button>
                  </div>
                  <button type="button" @click.prevent="load_runner_type_sex()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="refresh-cw" size="18"></vue-feather> Refresh
                  </button>
                  <!-- Export Chart Button (only show when chart view is active) -->
                  <button v-if="showSexChart" type="button" @click.prevent="exportSexChartAsImage()" class="btn btn-success px-2 py-1 text-sm">
                    <vue-feather type="download" size="18"></vue-feather> Export Chart
                  </button>
                </div>
              </div>
            </div>

            <!-- Chart View -->
            <div v-if="showSexChart && report_runner_type_sex.length > 0 && is_loading_runner_type_sex === 'N'" class="card-body px-2 py-3">
              <div class="row gx-2">
                <div class="col-md-8">
                  <div class="chart-container" style="position: relative; height: 368px; padding: 5px;">
                    <canvas ref="runnerTypeSexChart"></canvas>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="chart-legend">
                    <h6 class="mb-3"><b>รายละเอียด</b></h6>
                    <div v-for="(item, index) in getSexChartData()" :key="index" class="legend-item mb-2">
                      <div class="d-flex align-items-center">
                        <div class="legend-color" :style="{ backgroundColor: getSexChartColor(index) }"></div>
                        <div class="legend-text">
                          <div class="legend-name">{{ item.label }}</div>
                          <div class="legend-count">{{ item.value }} คน</div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3 pt-3 border-top">
                      <div class="total-summary">
                        <strong>รวมทั้งหมด: {{ getTotalSexRunners() }} คน</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table View -->
            <div v-if="!showSexChart" class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">ประเภทการเเข่งขัน</th>
                    <th style="text-align: left">เพศ</th>
                    <th style="text-align: center">จำนวนผู้สมัคร</th>
                    <th style="text-align: center">เปอร์เซ็นต์</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_runner_type_sex === 'Y'">
                  <tr>
                    <td colspan="16">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_runner_type_sex.length !== 0">
                  <tr v-for="item, index in this.report_runner_type_sex" :key="item">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: left" v-html="item.run_type_name"></td>
                    <td style="text-align: left">{{ item.sex }}</td>
                    <td style="text-align: center">{{ item.count_number }}</td>
                    <td style="text-align: center">{{ getSexPercentage(item.count_number) }}%</td>
                  </tr>
                  <!-- Total Row -->
                  <tr style="background-color: #f8f9fa; font-weight: bold; border-top: 2px solid #dee2e6;">
                    <td style="text-align: center">-</td>
                    <td style="text-align: left" colspan="2"><strong>รวม</strong></td>
                    <td style="text-align: center"><strong>{{ getTotalSexRunners() }}</strong></td>
                    <td style="text-align: center"><strong>100.0%</strong></td>
                  </tr>
                </tbody >
                <tbody v-if="this.report_runner_type_sex.length === 0">
                  <tr>
                    <td colspan="16">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Loading State -->
            <div v-if="is_loading_runner_type_sex === 'Y'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center">
                  <img style="width: 60px" src="../../assets/images/running_loading.svg" />
                  <div class="mt-3">กำลังโหลดข้อมูล...</div>
                </div>
              </div>
            </div>

            <!-- No Data State -->
            <div v-if="report_runner_type_sex.length === 0 && is_loading_runner_type_sex === 'N'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center text-muted">
                  <vue-feather type="bar-chart" size="48" class="mb-3"></vue-feather>
                  <div>ไม่พบข้อมูลผู้สมัคร</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top d-flex align-items-center justify-content-between">
                <h5 class="m-0"><b>จำนวนเสื้อ แต่ละขนาด</b></h5>
                <div class="d-flex gap-2">
                  <button type="button" @click.prevent="load_tshirt()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="refresh-cw" size="18"></vue-feather> Refresh
                  </button>
                  <button type="button" @click.prevent="load_report_runner_tshirt_excel()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="download" size="18"></vue-feather> Export
                  </button>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">ประเภทเสื้อ</th>
                    <th style="text-align: center">จำนวน</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_tshirt === 'Y'">
                  <tr>
                    <td colspan="15">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_tshirt.length !== 0">
                  <tr v-for="item, index in this.report_tshirt" :key="item">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: left"><div v-html="item.t_shirt_name"></div></td>
                    <td style="text-align: center">{{ item.count_number }}</td>
                  </tr>
                </tbody >
                <tbody v-if="this.report_tshirt.length === 0">
                  <tr>
                    <td colspan="15">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>จำนวนเสื้อ แต่ละขนาด แยกตามชนิดการแข่งขัน</b></h5>
                <div class="d-flex gap-2">
                  <button type="button" @click.prevent="load_type_tshirt()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="refresh-cw" size="18"></vue-feather> Refresh
                  </button>
                  <button type="button" @click.prevent="load_type_tshirt_excel()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="download" size="18"></vue-feather> Export
                  </button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">ประเภทการแข่งขัน</th>
                    <th style="text-align: left">ประเภทเสื้อ</th>
                    <th style="text-align: center">จำนวน</th>
                    <th style="text-align: center">ดาวน์โหลดข้อมูลผู้สมัคร</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_type_tshirt === 'Y'">
                  <tr>
                    <td colspan="5">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_type_tshirt.length !== 0">
                  <tr v-for="item, index in this.report_type_tshirt" :key="item">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: left"><div v-html="item.run_type_name"></div></td>
                    <td style="text-align: left"><div v-html="item.t_shirt_name"></div></td>
                    <td style="text-align: center">{{ item.count_number }}</td>
                    <td style="text-align: center">
                      <button
                        v-if="item.run_type_name === '-' && item.t_shirt_name !== '-'"
                        type="button"
                        class="btn btn-primary btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0"
                        style="width: 30px; height: 30px;"
                        title="Export Excel"
                        aria-label="Export Excel"
                        :disabled="is_loading_order_excel_all === 'Y'"
                        @click="load_order_excel_all()">
                        <span v-if="is_loading_order_excel_all === 'Y'" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <vue-feather v-else type="download" size="14"></vue-feather>
                      </button>
                      <button
                        v-else-if="item.t_shirt_name !== '-'"
                        type="button"
                        class="btn btn-outline-primary btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0"
                        style="width: 30px; height: 30px;"
                        title="Export Excel"
                        aria-label="Export Excel"
                        :disabled="is_loading_order_excel_tshirt === item.t_shirt_name"
                        @click="load_order_excel_tshirt(item.t_shirt_name)">
                        <span v-if="is_loading_order_excel_tshirt === item.t_shirt_name" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <vue-feather v-else type="download" size="14"></vue-feather>
                      </button>
                    </td>
                  </tr>
                </tbody >
                <tbody v-if="this.report_type_tshirt.length === 0">
                  <tr>
                    <td colspan="5">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top"> 
                <h5 class="m-0"><b>สถานะ คำสั่งซื้อ</b><span style="font-size: small;"> (1 คำสั่งซื้อสามารถสมัครได้มากกว่า 1 คน)</span></h5>
                <div class="d-flex align-items-center gap-3">
                  <!-- View Toggle Buttons -->
                  <div class="btn-group" role="group" aria-label="View toggle">
                    <button type="button" 
                            :class="['btn', showOrderChart ? 'btn-primary' : 'btn-outline-primary']"
                            @click="showOrderChart = true">
                      <vue-feather type="pie-chart" size="16"></vue-feather> กราฟ
                    </button>
                    <button type="button" 
                            :class="['btn', !showOrderChart ? 'btn-primary' : 'btn-outline-primary']"
                            @click="showOrderChart = false">
                      <vue-feather type="grid" size="16"></vue-feather> ตาราง
                    </button>
                  </div>
                  <button type="button" @click.prevent="load_order_count()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="refresh-cw" size="18"></vue-feather> Refresh
                  </button>
                  <!-- Export Chart Button (only show when chart view is active) -->
                  <button v-if="showOrderChart" type="button" @click.prevent="exportOrderChartAsImage()" class="btn btn-success px-2 py-1 text-sm">
                    <vue-feather type="download" size="18"></vue-feather> Export Chart
                  </button>
                  <button type="button" @click.prevent="load_order_unpaid_excel()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="download" size="18"></vue-feather> Export
                  </button>
                </div>
              </div>
            </div>

            <!-- Chart View -->
            <div v-if="showOrderChart && report_order_count.length > 0 && is_loading_order_count === 'N'" class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="chart-container" style="position: relative; height: 300px;">
                    <canvas ref="orderStatusChart"></canvas>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="chart-legend">
                    <h6 class="mb-3"><b>รายละเอียด</b></h6>
                    <div v-for="(item, index) in getOrderChartData()" :key="index" class="legend-item mb-2">
                      <div class="d-flex align-items-center">
                        <div class="legend-color" :style="{ backgroundColor: getOrderChartColor(index) }"></div>
                        <div class="legend-text">
                          <div class="legend-name">{{ item.label }}</div>
                          <div class="legend-count">{{ item.value }} คำสั่ง</div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3 pt-3 border-top">
                      <div class="total-summary">
                        <strong>รวมทั้งหมด: {{ getTotalOrders() }} คำสั่ง</strong> <span style="font-size: xx-small;">(1 คำสั่งซื้อสามารถสมัครได้มากกว่า 1 คน)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table View -->
            <div v-if="!showOrderChart" class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">สถานะ</th>
                    <th style="text-align: center">จำนวนคำสั่งซื้อ</th>
                    <th style="text-align: center">เปอร์เซ็นต์</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_order_count === 'Y'">
                  <tr>
                    <td colspan="16">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_order_count.length !== 0">
                  <tr v-for="item, index in this.report_order_count" :key="item">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td v-if="item.status === 'INITIAL'" style="text-align: left;">
                      <vue-feather type="clock" size="18" style="color: #ff9800; vertical-align: middle;"></vue-feather>
                      <span style="color: #ff9800; margin-left: 8px;">รอชำระเงิน</span>
                    </td>
                    <td v-if="item.status === 'PAID'" style="text-align: left;">
                      <vue-feather type="check-circle" size="18" style="color: #28a745; vertical-align: middle;"></vue-feather>
                      <span style="color: #28a745; margin-left: 8px;">ชำระเงินสำเร็จ</span>
                    </td>
                    <td v-if="item.status === 'CANCEL'" style="text-align: left;color: orange;">ยกเลิก</td>
                    <td style="text-align: center">{{ item.count_number }}</td>
                    <td style="text-align: center">{{ getOrderPercentage(item.count_number) }}%</td>
                  </tr>
                  <!-- Total Row -->
                  <tr style="background-color: #f8f9fa; font-weight: bold; border-top: 2px solid #dee2e6;">
                    <td style="text-align: center">-</td>
                    <td style="text-align: left"><strong>รวม</strong></td>
                    <td style="text-align: center"><strong>{{ getTotalOrders() }}</strong></td>
                    <td style="text-align: center"><strong>100.0%</strong></td>
                  </tr>
                </tbody>
                <tbody>

                </tbody>
              </table>
            </div>

            <!-- Loading State -->
            <div v-if="is_loading_order_count === 'Y'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center">
                  <img style="width: 60px" src="../../assets/images/running_loading.svg" />
                  <div class="mt-3">กำลังโหลดข้อมูล...</div>
                </div>
              </div>
            </div>

            <!-- No Data State -->
            <div v-if="report_order_count.length === 0 && is_loading_order_count === 'N'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center text-muted">
                  <vue-feather type="bar-chart" size="48" class="mb-3"></vue-feather>
                  <div>ไม่พบข้อมูลคำสั่งซื้อ</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>รายได้ค่าสมัคร</b></h5>
                <button type="button" @click.prevent="load_order_amt()" class="btn btn-primary px-2 py-1 text-sm" >
                <vue-feather type="refresh-cw" size="18"> </vue-feather> Refresh
              </button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">ยอดรวมค่าสมัคร</th>
                    <th style="text-align: center">ค่าจัดส่ง</th>
                    <th style="text-align: center">รวม</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_order_amt === 'Y'">
                  <tr>
                    <td colspan="15">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_order_amt.length !== 0">
                  <tr v-for="item, index in this.report_order_amt" :key="item">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: left">{{ item.amount }}</td>
                    <td style="text-align: center">{{ item.delivery_type_price }}</td>
                    <td style="text-align: center">{{ item.total }}</td>
                  </tr>
                </tbody>
                <tbody>

                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>Export รายงาน</b></h5>
                
              </div>
            </div>
            <div class="card-body">
              <div class="export-list">
                <!-- Export All Data -->
                <div class="export-list-item">
                  <div class="export-list-icon">
                    <vue-feather type="database" size="20" class="text-primary"></vue-feather>
                  </div>
                  <div class="export-list-content">
                    <h6 class="export-list-title">ข้อมูลผู้สมัครทั้งหมด</h6>
                    <p class="export-list-desc">ดาวน์โหลดข้อมูลผู้สมัครทั้งหมดและรายละเอียด</p>
                    <div v-if="exportRunTypes.length" class="export-run-type-actions">
                      <span v-for="runType in exportRunTypes" :key="runType.id" class="export-run-type-item">
                        <button
                          type="button"
                          class="btn btn-outline-primary btn-sm"
                          :disabled="is_loading_order_excel_run_type === runType.name"
                          @click="load_order_excel_run_type(runType.name)">
                          <span v-if="is_loading_order_excel_run_type === runType.name" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                          <vue-feather v-else type="download" size="13"></vue-feather>
                          {{ runType.name }}
                        </button>
                      </span>
                      <span class="export-run-type-item">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          :disabled="is_loading_order_excel_all === 'Y'"
                          @click="load_order_excel_all()">
                          <span v-if="is_loading_order_excel_all === 'Y'" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                          <vue-feather v-else type="download" size="13"></vue-feather>
                          ทั้งหมด
                        </button>
                      </span>
                    </div>
                  </div>
                  
                </div>

                <!-- Export Delivery Data -->
                <div class="export-list-item">
                  <div class="export-list-icon">
                    <vue-feather type="truck" size="20" class="text-success"></vue-feather>
                  </div>
                  <div class="export-list-content">
                    <h6 class="export-list-title">ข้อมูลผู้สมัครที่ต้องจัดส่งเสื้อ</h6>
                    <p class="export-list-desc">รายชื่อผู้สมัครที่เลือกให้จัดส่งเสื้อไปตามที่อยู่ที่ให้มาในระบบ</p>
                  </div>
                  <div class="export-list-action">
                    <button :disabled="this.is_loading_order_excel_delivery === 'Y'" 
                            type="button" 
                            @click="load_order_excel_delivery()" 
                            class="btn btn-outline-success">
                      <span v-if="this.is_loading_order_excel_delivery === 'Y'" 
                            class="spinner-border spinner-border-sm me-2" 
                            role="status" 
                            aria-hidden="true"></span>
                      <vue-feather v-else type="download" size="16"></vue-feather>
                    </button>
                  </div>
                </div>

                <!-- Export Self Pickup Data -->
                <div class="export-list-item">
                  <div class="export-list-icon">
                    <vue-feather type="user-check" size="20" class="text-info"></vue-feather>
                  </div>
                  <div class="export-list-content">
                    <h6 class="export-list-title">ข้อมูลผู้สมัครที่มารับเสื้อด้วยตนเอง</h6>
                    <p class="export-list-desc">ข้อมูลผู้สมัครที่มารับเสื้อด้วยตนเอง (ถ้ามี)</p>
                  </div>
                  <div class="export-list-action">
                    <button :disabled="this.is_loading_order_excel_self === 'Y'" 
                            type="button" 
                            @click="load_order_excel_self()" 
                            class="btn btn-outline-info">
                      <span v-if="this.is_loading_order_excel_self === 'Y'" 
                            class="spinner-border spinner-border-sm me-2" 
                            role="status" 
                            aria-hidden="true"></span>
                      <vue-feather v-else type="download" size="16"></vue-feather>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12" v-if="this.eventDetails.is_enable_refund === 'Y'">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>Export รายงาน (คืนเงิน) &nbsp;<span v-if="this.is_loading_refund_order_excel === 'Y'" 
                            class="spinner-border spinner-border-sm me-2" 
                            role="status" style="color: orange;"
                            aria-hidden="true"></span></b></h5>
                
              </div>
            </div>
            <div class="card-body">
              <div class="export-list">
                <!-- Export All Data -->
                 <div class="export-list-item">
                  <div class="export-list-icon">
                    <vue-feather type="database" size="20" class="text-primary"></vue-feather>
                  </div>
                  <div class="export-list-content">
                    <h6 class="export-list-title">ข้อมูลผู้สมัครทั้งหมด</h6>
                    <p class="export-list-desc">ข้อมูลผู้สมัครทั้งหมด อาจจะนำไปใช้สำหรับการตรวจสอบ และ Filter ข้อมูลการคืนเงิน สถานะต่างๆในระบบ</p>
                  </div>
                  <div class="export-list-action">
                    <button :disabled="this.is_loading_refund_order_excel === 'Y'" 
                            type="button" 
                            @click="refund_request_order_excel('ALL')" 
                            class="btn btn-outline-primary">
                      <span v-if="this.is_loading_refund_order_excel === 'Y'" 
                            class="spinner-border spinner-border-sm me-2" 
                            role="status" 
                            aria-hidden="true"></span>
                      <vue-feather v-else type="download" size="16"></vue-feather>
                    </button>
                  </div>
                </div>
                <div class="export-list-item">
                  <div class="export-list-icon">
                    <vue-feather type="rotate-ccw" size="20" class="text-warning"></vue-feather>
                  </div>
                  <div class="export-list-content">
                    <h6 class="export-list-title">ข้อมูลผู้สมัครที่รอป้อนข้อมูลขอคืนเงิน</h6>
                    <p class="export-list-desc">ข้อมูลผู้สมัครที่รอป้อนข้อมูลขอคืนเงิน (ผู้สมัครยังไม่ป้อนข้อมูล หรือส่งคำขอคืนเงิน) อาจจะใช้สำหรับการโทรแจ้งผู้สมัคร เพื่อเข้ามากรอกข้อมูล</p>
                  </div>
                  <div class="export-list-action">
                    <button :disabled="this.is_loading_refund_order_excel === 'Y'"
                            type="button" 
                            @click="refund_request_order_excel('REFUND_WAITING')" 
                            class="btn btn-outline-warning">
                      <span v-if="this.is_loading_refund_order_excel === 'Y'" 
                            class="spinner-border spinner-border-sm me-2" 
                            role="status" 
                            aria-hidden="true"></span>
                      <vue-feather v-else type="download" size="16"></vue-feather>
                    </button>
                  </div>
                </div>

                <!-- Export Delivery Data -->
                <div class="export-list-item">
                  <div class="export-list-icon">
                    <vue-feather type="clock" size="20" class="text-warning"></vue-feather>
                  </div>
                  <div class="export-list-content">
                    <h6 class="export-list-title">ข้อมูลผู้สมัครที่ขอคืนเงิน</h6>
                    <p class="export-list-desc">ดาวน์โหลดข้อมูลผู้สมัครที่ขอคืนเงิน (REQUEST)</p>
                  </div>
                  <div class="export-list-action">
                    <button :disabled="this.is_loading_refund_order_excel === 'Y'" 
                            type="button" 
                            @click="refund_request_order_excel('REFUND_REQUEST')" 
                            class="btn btn-outline-warning">
                      <span v-if="this.is_loading_refund_order_excel === 'Y'" 
                            class="spinner-border spinner-border-sm me-2" 
                            role="status" 
                            aria-hidden="true"></span>
                      <vue-feather v-else type="download" size="16"></vue-feather>
                    </button>
                  </div>
                </div>

                <!-- Export Self Pickup Data -->
                <div class="export-list-item">
                  <div class="export-list-icon">
                    <vue-feather type="check" size="20" class="text-success "></vue-feather>
                  </div>
                  <div class="export-list-content">
                    <h6 class="export-list-title">ข้อมูลผู้สมัครที่ขอคืนเงิน และโอนเงินสำเร็จ</h6>
                    <p class="export-list-desc">ข้อมูลผู้สมัครที่ขอคืนเงิน และโอนเงินสำเร็จ (COMPLETED)</p>
                  </div>
                  <div class="export-list-action">
                    <button :disabled="this.is_loading_refund_order_excel === 'Y'" 
                            type="button" 
                            @click="refund_request_order_excel('REFUND_COMPLETE')" 
                            class="btn btn-outline-success">
                      <span v-if="this.is_loading_refund_order_excel === 'Y'" 
                            class="spinner-border spinner-border-sm me-2" 
                            role="status" 
                            aria-hidden="true"></span>
                      <vue-feather v-else type="download" size="16"></vue-feather>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>ข้อมูลจังหวัด </b><span style="color: red;font-size: small;">(ข้อมูลยังไม่ครบถ้วนเนื่องจากมีการเก็บข้อมูลหลังจากสมัครไปแล้ว)</span></h5>
                <div class="d-flex align-items-center gap-3">
                  <!-- View Toggle Buttons -->
                  <div class="btn-group" role="group" aria-label="View toggle">
                    <button type="button" 
                            @click="showProvinceChart = true" 
                            :class="['btn', 'btn-sm', showProvinceChart ? 'btn-primary' : 'btn-outline-primary']">
                      <vue-feather type="bar-chart-2" size="16"></vue-feather> กราฟ
                    </button>
                    <button type="button" 
                            @click="showProvinceChart = false" 
                            :class="['btn', 'btn-sm', !showProvinceChart ? 'btn-primary' : 'btn-outline-primary']">
                      <vue-feather type="grid" size="16"></vue-feather> ตาราง
                    </button>
                  </div>
                  <button type="button" @click.prevent="load_current_province()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="refresh-cw" size="18"></vue-feather> Refresh
                  </button>
                  <button type="button" @click.prevent="load_report_current_province_excel()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="download" size="18"></vue-feather> Export Excel
                  </button>
                </div>
              </div>
            </div>

            <!-- Chart View -->
            <div v-if="showProvinceChart && report_current_province.length > 0 && is_loading_current_province === 'N'" class="card-body px-2 py-3">
              <div class="chart-container" style="position: relative; height: 600px; padding: 5px;">
                <canvas ref="provinceChart"></canvas>
              </div>
              <div class="text-center mt-3">
                <small class="text-muted">แสดงจังหวัดที่มีผู้สมัครทั้งหมด</small>
              </div>
            </div>

            <!-- Table View -->
            <div v-if="!showProvinceChart" class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">จังหวัด</th>
                    <th style="text-align: center">จำนวน</th>
                    <th style="text-align: center">เปอร์เซ็นต์</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_current_province === 'Y'">
                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_current_province.length !== 0">
                  <tr v-for="item, index in this.report_current_province" :key="item">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: left"><div v-html="item.current_province"></div></td>
                    <td style="text-align: center">{{ item.count_number }}</td>
                    <td style="text-align: center">{{ getProvincePercentage(item.count_number) }}%</td>
                  </tr>
                  <!-- Total Row -->
                  <tr style="background-color: #f8f9fa; font-weight: bold; border-top: 2px solid #dee2e6;">
                    <td style="text-align: center">-</td>
                    <td style="text-align: left"><strong>รวม</strong></td>
                    <td style="text-align: center"><strong>{{ getTotalProvinces() }}</strong></td>
                    <td style="text-align: center"><strong>100.0%</strong></td>
                  </tr>
                </tbody >
                <tbody v-if="this.report_current_province.length === 0">
                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Loading State -->
            <div v-if="is_loading_current_province === 'Y'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center">
                  <img style="width: 60px" src="../../assets/images/running_loading.svg" />
                  <div class="mt-3">กำลังโหลดข้อมูล...</div>
                </div>
              </div>
            </div>

            <!-- No Data State -->
            <div v-if="report_current_province.length === 0 && is_loading_current_province === 'N'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center text-muted">
                  <vue-feather type="map" size="48" class="mb-3"></vue-feather>
                  <div>ไม่พบข้อมูลจังหวัด</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- new -->

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>จำนวนผู้ลงทะเบียนแต่ละวัน</b></h5>
                <div class="d-flex align-items-center gap-3">
                  <!-- View Toggle Buttons -->
                  <div class="btn-group" role="group" aria-label="View toggle">
                    <button type="button" 
                            @click="showRegisDateChart = true" 
                            :class="['btn', 'btn-sm', showRegisDateChart ? 'btn-primary' : 'btn-outline-primary']">
                      <vue-feather type="bar-chart-2" size="16"></vue-feather> กราฟ
                    </button>
                    <button type="button" 
                            @click="showRegisDateChart = false" 
                            :class="['btn', 'btn-sm', !showRegisDateChart ? 'btn-primary' : 'btn-outline-primary']">
                      <vue-feather type="grid" size="16"></vue-feather> ตาราง
                    </button>
                  </div>
                  <button type="button" @click.prevent="load_regis_date()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="refresh-cw" size="18"></vue-feather> Refresh
                  </button>
                  <button type="button" @click.prevent="load_report_runner_regis_date_excel()" class="btn btn-primary px-2 py-1 text-sm">
                    <vue-feather type="download" size="18"></vue-feather> Export Excel
                  </button>
                </div>
              </div>
            </div>

            <!-- Chart View -->
            <div v-if="showRegisDateChart && report_regis_date.length > 0 && is_loading_regis_date === 'N'" class="card-body px-2 py-3">
              <div class="chart-container" style="position: relative; height: 600px; padding: 5px;">
                <canvas ref="regisDateChart"></canvas>
              </div>
              <div class="text-center mt-3">
                <small class="text-muted">แสดงจำนวนผู้ลงทะเบียนแต่ละวัน</small>
              </div>
            </div>

            <!-- Table View -->
            <div v-if="!showRegisDateChart" class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">วันที่ลงทะเบียน</th>
                    <th style="text-align: center">จำนวน</th>
                    <th style="text-align: center">เปอร์เซ็นต์</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading_regis_date === 'Y'">
                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.report_regis_date.length !== 0">
                  <tr v-for="item, index in this.report_regis_date" :key="item">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: left"><div v-html="item.regis_date"></div></td>
                    <td style="text-align: center">{{ item.count_number }}</td>
                    <td style="text-align: center">{{ getRegisDatePercentage(item.count_number) }}%</td>
                  </tr>
                  <!-- Total Row -->
                  <tr style="background-color: #f8f9fa; font-weight: bold; border-top: 2px solid #dee2e6;">
                    <td style="text-align: center">-</td>
                    <td style="text-align: left"><strong>รวม</strong></td>
                    <td style="text-align: center"><strong>{{ getTotalRegisDate() }}</strong></td>
                    <td style="text-align: center"><strong>100.0%</strong></td>
                  </tr>
                </tbody >
                <tbody v-if="this.report_regis_date.length === 0">
                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Loading State -->
            <div v-if="is_loading_regis_date === 'Y'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center">
                  <img style="width: 60px" src="../../assets/images/running_loading.svg" />
                  <div class="mt-3">กำลังโหลดข้อมูล...</div>
                </div>
              </div>
            </div>

            <!-- No Data State -->
            <div v-if="report_regis_date.length === 0 && is_loading_regis_date === 'N'" class="card-body">
              <div class="d-flex justify-content-center align-items-center" style="height: 400px;">
                <div class="text-center text-muted">
                  <vue-feather type="calendar" size="48" class="mb-3"></vue-feather>
                  <div>ไม่พบข้อมูลการลงทะเบียน</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        

      </div>
    </div>
  </div>
</template>

<script>
import welcomecard from "./user_welcomecard.vue";
import axios from "axios";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  ArcElement,
  DoughnutController,
  PieController
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  ArcElement,
  DoughnutController,
  PieController
)

export default {
  components: {
    welcomecard,
  },
  data() {
    return {
      is_authorization: null,
      eventDetails: {},
      token: null,
      is_loading_runner_type: "N",
      report_runner_type: [],

      is_loading_runner_type_sex: "N",
      report_runner_type_sex: [],

      is_loading_tshrt: "N",
      report_tshirt: [],

      is_loading_regis_date: "N",
      report_regis_date: [],

      order_filter_type: "mobile",
      order_filter_value: "",
      is_loading_last_registration: "N",
      report_last_registration: [],
      current_page: 1,
      page_size: 20,
      total_records: 0,
      total_pages: 0,
      current_registration_filter: "",

      is_loading_order_count: "N",
      report_order_count: [],

      is_loading_order_amt: "N",
      report_order_amt: [],

      is_loading_current_province: "N",
      report_current_province: [],

      is_loading_direct_notify: "N",
      report_direct_notify: [],

      is_loading_type_tshirt: "N",
      report_type_tshirt: [],
      

      is_loading_order_excel_all: "N",
      is_loading_order_excel_delivery: "N",
      is_loading_order_excel_self: "N",
      is_loading_order_excel_run_type: null,
      is_loading_order_excel_tshirt: null,
      exportRunTypes: [],


      is_loading_refund_order_excel: "N",

      // Chart related data
      runnerTypeChart: null,
      runnerTypeSexChart: null,
      orderStatusChart: null,
      provinceChart: null,
      regisDateChart: null,
      showChart: true, // สวิตช์สำหรับเลือกดูกราฟหรือตาราง (รายงานแต่ละประเภท)
      showSexChart: true, // สวิตช์สำหรับเลือกดูกราฟหรือตาราง (เริ่มต้นแสดงกราฟ)
      showOrderChart: true, // สวิตช์สำหรับเลือกดูกราฟหรือตาราง (สถานะคำสั่งซื้อ)
      showProvinceChart: true, // สวิตช์สำหรับเลือกดูกราฟหรือตาราง (ข้อมูลจังหวัด)
      showRegisDateChart: true, // สวิตช์สำหรับเลือกดูกราฟหรือตาราง (จำนวนผู้ลงทะเบียนแต่ละวัน)
      chartColors: [
        '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', 
        '#9966FF', '#FF9F40', '#FF6384', '#C9CBCF',
        '#4BC0C0', '#FF6384', '#36A2EB', '#FFCE56'
      ]
    }
  },
  
  watch: {
    // Watch for changes in runner type data to create chart
    report_runner_type: {
      handler(newData) {
        if (newData && newData.length > 0 && this.showChart) {
          this.$nextTick(() => {
            this.createChart();
          });
        }
      },
      deep: true
    },
    
    // Watch for view toggle changes (main chart)
    showChart(newValue) {
      if (newValue && this.report_runner_type.length > 0) {
        this.$nextTick(() => {
          this.createChart();
        });
      }
    },
    
    // Watch for changes in runner type sex data to create chart
    report_runner_type_sex: {
      handler(newData) {
        if (newData && newData.length > 0 && this.showSexChart) {
          this.$nextTick(() => {
            this.createSexChart();
          });
        }
      },
      deep: true
    },
    
    // Watch for view toggle changes
    showSexChart(newValue) {
      if (newValue && this.report_runner_type_sex.length > 0) {
        this.$nextTick(() => {
          this.createSexChart();
        });
      }
    },
    
    // Watch for changes in order count data to create chart
    report_order_count: {
      handler(newData) {
        if (newData && newData.length > 0 && this.showOrderChart) {
          this.$nextTick(() => {
            this.createOrderChart();
          });
        }
      },
      deep: true
    },
    
    // Watch for view toggle changes (order chart)
    showOrderChart(newValue) {
      if (newValue && this.report_order_count.length > 0) {
        this.$nextTick(() => {
          this.createOrderChart();
        });
      }
    },
    
    // Watch for changes in province data to create chart
    report_current_province: {
      handler(newData) {
        if (newData && newData.length > 0 && this.showProvinceChart) {
          this.$nextTick(() => {
            this.createProvinceChart();
          });
        }
      },
      deep: true
    },
    
    // Watch for view toggle changes (province chart)
    showProvinceChart(newValue) {
      if (newValue && this.report_current_province.length > 0) {
        this.$nextTick(() => {
          this.createProvinceChart();
        });
      }
    },
    
    // Watch for changes in registration date data to create chart
    report_regis_date: {
      handler(newData) {
        if (newData && newData.length > 0 && this.showRegisDateChart) {
          this.$nextTick(() => {
            this.createRegisDateChart();
          });
        }
      },
      deep: true
    },
    
    // Watch for view toggle changes (regis date chart)
    showRegisDateChart(newValue) {
      if (newValue && this.report_regis_date.length > 0) {
        this.$nextTick(() => {
          this.createRegisDateChart();
        });
      }
    }
  },
  
  async mounted() {
    this.token = localStorage.getItem("_rr_token");
    if(this.token !== null){
      await this.authorization()
      if(this.is_authorization === "Y"){
        this.getEventDetail(this.$route.params.event_key);
        this.clearLatestOrder();
        this.load_runner_type();
        this.load_runner_type_sex();
        this.load_order_count();
        this.load_type_tshirt();
        this.load_current_province();
        this.load_regis_date();
        //this.load_order_amt();
      }
      

    }else{
      //alert("เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง")
      this.$router.push("/auth/login");
    }
    
  },
  methods: {
    async load_regis_date() {
      this.is_loading_regis_date = "Y"
      this.report_regis_date = [];
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      const res = await axios.post("v1/organizer/report-runner-regis-date", data, { headers });
      //console.log("res report-runner-tshirt:", res)
      if (res.data.status === 'success') {
        this.report_regis_date = res.data.body
        this.is_loading_regis_date = "N"
      } else {

        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_regis_date")
        this.is_loading_regis_date = "N"
      }
    },

    async delete_order(_uuid,_mobile_no){
      if(confirm("ยืนยันการ ลบข้อมูล \nสั่งซื้อ: "+_uuid+" \nหมายเลขโทรศัพท์ "+_mobile_no+"")){
          const data = {
            event_key: this.$route.params.event_key,
            uuid: _uuid,
            payment_method: this.eventDetails.payment_method
          };
          const headers = {
            'Authorization': 'Bearer ' + this.token
          };
          const res = await axios.post("v1/organizer/delete-order", data, { headers });
          if (res.data.status === 'success') {
            alert("ลบข้อมูลเรียบร้อยแล้ว")
            this.is_loading_direct_notify = "N"
            this.load_last_registration(this.current_registration_filter, false);
          } else {

            alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: "+res.data.message	)
            this.is_loading_direct_notify = "N"
          }
      }
    },
    async authorization(_uuid,_mobile_no){
            const data = {
              event_key: this.$route.params.event_key
            };
            const headers = {
              'Authorization': 'Bearer ' + this.token
            };
            const res = await axios.post("v1/organizer/authorization", data, { headers });
            if (res.data.status === 'success') {
              this.report_direct_notify = res.data.body
              this.is_authorization = res.data.message.is_authorization
            } else {
              alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: "+res.data.message	)
            }
        },  
    async direct_notify(_uuid,_mobile_no,_id_card){

      //check direct-notify-checking
      const data_check = {
            event_key: this.$route.params.event_key,
            uuid: _uuid,
            id_card: _id_card
      };
      const headers = {
            'Authorization': 'Bearer ' + this.token
      };
      const res_check = await axios.post("v1/organizer/direct-notify-checking", data_check, { headers });
      if (res_check.data.status === 'success') {
        if(confirm("ยืนยันการรับชำระคำเงิน \nสั่งซื้อ: "+_uuid+" \nหมายเลขโทรศัพท์ "+_mobile_no+"")){
            const data = {
              event_key: this.$route.params.event_key,
              uuid: _uuid
            };
            
            const res = await axios.post("v1/organizer/direct-notify", data, { headers });
            if (res.data.status === 'success') {
              this.report_direct_notify = res.data.body
              this.is_loading_direct_notify = "N"
              this.load_last_registration(this.current_registration_filter, false);
            } else {

              alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: "+res.data.message	)
              this.is_loading_direct_notify = "N"
            }
          }
      }else if(res_check.data.status === 'duplicate'){
        if(confirm(res_check.data.message)){
          if(confirm("ยืนยันการรับชำระคำเงิน \nสั่งซื้อ: "+_uuid+" \nหมายเลขโทรศัพท์ "+_mobile_no+"")){
            const data = {
              event_key: this.$route.params.event_key,
              uuid: _uuid
            };
            
            const res = await axios.post("v1/organizer/direct-notify", data, { headers });
            if (res.data.status === 'success') {
              this.report_direct_notify = res.data.body
              this.is_loading_direct_notify = "N"
              this.load_last_registration(this.current_registration_filter, false);
            } else {

              alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: "+res.data.message	)
              this.is_loading_direct_notify = "N"
            }
          }
        }
      }else{
          alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: "+res_check.data.message	)
          this.is_loading_direct_notify = "N"
      }



      

      

    },
    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/initial/" + event_key);
      //console.log("res.data", JSON.stringify(res.data))
      if (res.data.status === "success") {
        this.eventDetails = res.data.body[0];
        await this.load_export_run_types(event_key);
        // //this.eventPackage = res.data.package;

        // return res.data;
      } else {
        //alert("พบข้อผิดพลาด! ไม่พบ url ของกิจกรรม");
        router.push({ path: "/404" });
      }
    },
    async load_runner_type() {
      this.is_loading_runner_type = "Y"
      this.report_runner_type = [];
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      const res = await axios.post("v1/organizer/report-runner-type", data, { headers });
      //console.log("res:", res)
      if (res.data.status === 'success') {
        this.report_runner_type = res.data.body
        this.is_loading_runner_type = "N"
        
        // Create chart when data is loaded and chart view is active
        if (this.report_runner_type.length > 0 && this.showChart) {
          this.$nextTick(() => {
            try {
              this.createChart();
            } catch (error) {
              console.error('Error creating chart:', error);
            }
          });
        }
      } else {
        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_runner_type")
        this.is_loading_runner_type = "N"
      }
    },
    async load_runner_type_sex() {
      this.is_loading_runner_type_sex = "Y"
      this.report_runner_type_sex = [];
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      const res = await axios.post("v1/organizer/report-runner-type-sex", data, { headers });
      //console.log("res:", res)
      if (res.data.status === 'success') {
        this.report_runner_type_sex = res.data.body
        this.is_loading_runner_type_sex = "N"
      } else {

        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_runner_type_sex")
        this.is_loading_runner_type_sex = "N"
      }
    },
    async load_tshirt() {
      this.is_loading_tshirt = "Y"
      this.report_tshirt = [];
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      const res = await axios.post("v1/organizer/report-runner-tshirt", data, { headers });
      //console.log("res report-runner-tshirt:", res)
      if (res.data.status === 'success') {
        this.report_tshirt = res.data.body
        this.is_loading_tshirt = "N"
      } else {

        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_tshirt")
        this.is_loading_tshirt = "N"
      }
    },
    async load_type_tshirt() {
      this.is_loading_type_tshirt = "Y"
      this.report_type_tshirt = [];
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      const res = await axios.post("v1/organizer/report-runner-type-tshirt", data, { headers });
      //console.log("res report-runner-type_tshirt:", JSON.stringify(res))
      if (res.data.status === 'success') {
        this.report_type_tshirt = res.data.body
        this.is_loading_type_tshirt = "N"
      } else {

        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_tshirt")
        this.is_loading_type_tshirt = "N"
      }
    },
    async clearLatestOrder(_filter) {
      this.order_filter_value = "";
      
      this.load_last_registration('');
    },
    async load_last_registration(_filter, _resetPage = true) {
      if(this.order_filter_type === "status"){
        this.order_filter_value = "รอชำระเงิน"
      }
      if (this.order_filter_value.length == 0 || this.order_filter_value.length >= 3){
        this.current_registration_filter = _filter;
        if(_resetPage){
          this.current_page = 1;
        }
        this.is_loading_last_registration = "Y"
        this.report_last_registration = [];
        let data = {
          event_key: this.$route.params.event_key,
          order_filter_type: this.order_filter_type,
          order_filter_value: this.order_filter_value,
          page: this.current_page
        };
        if(_filter === 'INITIAL_HAVE_SLIP'){
          data = {
            event_key: this.$route.params.event_key,
            order_filter_type: "INITIAL_HAVE_SLIP",
            order_filter_value: "spacial",
            page: this.current_page
          };
        }

        if(_filter === 'REFUND_REQUEST'){
          data = {
            event_key: this.$route.params.event_key,
            order_filter_type: "REFUND_REQUEST",
            order_filter_value: "spacial",
            page: this.current_page
          };
        }


        const headers = {
          'Authorization': 'Bearer ' + this.token
        };
        
        const res = await axios.post("v1/organizer/report-order-latest-pagination", data, { headers });
        //console.log("res:", res)
        if (res.data.status === 'success') {
          this.report_last_registration = res.data.body.list
          this.total_records = res.data.body.total
          this.total_pages = res.data.body.total_pages
          this.is_loading_last_registration = "N"
        } else {

          alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_last_registration")
          this.is_loading_last_registration = "N"
        }
      }

      
    },
    go_to_page(_page) {
      if (_page < 1 || _page > this.total_pages || _page === this.current_page) {
        return;
      }
      this.current_page = _page;
      this.load_last_registration(this.current_registration_filter, false);
    },
    getPaginationPages() {
      const total = this.total_pages;
      const current = this.current_page;
      const delta = 1;
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      const left = Math.max(2, current - delta);
      const right = Math.min(total - 1, current + delta);
      const pages = [1];
      if (left > 2) {
        pages.push('...');
      }
      for (let i = left; i <= right; i++) {
        pages.push(i);
      }
      if (right < total - 1) {
        pages.push('...');
      }
      pages.push(total);
      return pages;
    },
    async load_order_count() {
      this.is_loading_order_count = "Y"
      this.report_order_count = [];
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      const res = await axios.post("v1/organizer/report-order-count", data, { headers });
      //console.log("res:", res)
      if (res.data.status === 'success') {
        this.report_order_count = res.data.body
        this.is_loading_order_count = "N"
        
        // Create chart when data is loaded and chart view is active
        if (this.report_order_count.length > 0 && this.showOrderChart) {
          this.$nextTick(() => {
            try {
              this.createOrderChart();
            } catch (error) {
              console.error('Error creating order chart:', error);
            }
          });
        }
      } else {
        alert("พบข้อผิดพลาด")
        this.is_loading_order_count = "N"
      }
    },
    async load_order_amt() {
      this.is_loading_order_amt = "Y"
      this.report_order_amt = [];
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      const res = await axios.post("v1/organizer/report-order-amt", data, { headers });
      //console.log("res:", res)
      if (res.data.status === 'success') {
        this.report_order_amt = res.data.body
        this.is_loading_order_amt = "N"
      } else {

        alert("พบข้อผิดพลาด")
        this.is_loading_order_amt = "N"
      }
    },
    async load_type_tshirt_excel(){

      //this.is_loading_order_excel_all = "Y"
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      await axios({
          url: 'v1/organizer/report-runner-type-tshirt-excel',
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())
         

          const excel_report_file_name = "[จำนวนเสื้อ แต่ละขนาด แยกตามชนิดการแข่งขัน]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          link.setAttribute('download', excel_report_file_name); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          //this.is_loading_order_excel_all = "N"
      });
      //this.is_loading_order_excel_all = "N"
    },
    
    async refund_request_order_excel(_order_filter_type){

      this.is_loading_refund_order_excel = "Y"
      const data = {
        event_key: this.$route.params.event_key,
        order_filter_type: _order_filter_type,
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      await axios({
          url: 'v1/organizer/refund-order-excel-all',
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())
         

          let excel_report_file_name = "[REFUND-ALL]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          if(_order_filter_type === "REFUND_WAITING"){
            excel_report_file_name = "[REFUND-WAITING]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          }else if(_order_filter_type === "REFUND_REQUEST"){
            excel_report_file_name = "[REFUND-REQUEST]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          }else if(_order_filter_type === "REFUND_COMPLETE"){
            excel_report_file_name = "[REFUND-COMPLETE]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          }
          
          link.setAttribute('download', excel_report_file_name); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          this.is_loading_refund_order_excel = "N"
      });
      this.is_loading_refund_order_excel = "N"
    },

    async load_order_excel_all(){

      this.is_loading_order_excel_all = "Y"
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      await axios({
          url: 'v1/organizer/report-order-excel-all',
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())
         

          const excel_report_file_name = "[REPORT-ALL]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          link.setAttribute('download', excel_report_file_name); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          this.is_loading_order_excel_all = "N"
      });
      this.is_loading_order_excel_all = "N"
    },

    async load_export_run_types(event_key) {
      try {
        const res = await axios.get("/v1/events/" + event_key);
        if (res.data.status === "success") {
          this.exportRunTypes = Array.isArray(res.data.run_type_all) && res.data.run_type_all.length
            ? res.data.run_type_all
            : (Array.isArray(res.data.run_type) ? res.data.run_type : []);
        }
      } catch (error) {
        this.exportRunTypes = [];
      }
    },

    getExportTshirtTypes() {
      return [...new Set(this.report_type_tshirt
        .filter(item => item.run_type_name !== '-' && typeof item.t_shirt_name === 'string' && !item.t_shirt_name.includes('<'))
        .map(item => item.t_shirt_name))];
    },

    async load_order_excel_run_type(runTypeName) {
      return this.load_order_excel_filtered('run_type_name', runTypeName, 'is_loading_order_excel_run_type');
    },

    async load_order_excel_tshirt(tShirtName) {
      return this.load_order_excel_filtered('t_shirt_name', tShirtName, 'is_loading_order_excel_tshirt');
    },

    async load_order_excel_filtered(filterField, filterValue, loadingState) {
      this[loadingState] = filterValue;
      const data = {
        event_key: this.$route.params.event_key,
        [filterField]: filterValue
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };

      try {
        const response = await axios({
          url: 'v1/organizer/report-order-excel-all',
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
        });
        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, '');
        const safeFilterValue = String(filterValue).replace(/[\\/:*?"<>|]/g, '-');

        link.href = href;
        link.setAttribute('download', `[REPORT-${safeFilterValue}]${this.$route.params.event_key}-${timestamp}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      } catch (error) {
        alert('พบข้อผิดพลาดในการดาวน์โหลดรายงาน');
      } finally {
        this[loadingState] = null;
      }
    },

    async load_order_excel_delivery(){

      this.is_loading_order_excel_delivery = "Y"
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };

      await axios({
          url: 'v1/organizer/report-order-excel-delivery', 
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())
        

          const excel_report_file_name = "[REPORT-DELIVERY]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          link.setAttribute('download', excel_report_file_name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          this.is_loading_order_excel_delivery = "N"
      });
      this.is_loading_order_excel_delivery = "N"
    },
    async load_current_province() {
      this.is_loading_current_province = "Y"
      this.report_current_province = [];
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      const res = await axios.post("v1/organizer/report-runner-current-province", data, { headers });
      //console.log("res report-runner-current-province:", res)
      if (res.data.status === 'success') {
        this.report_current_province = res.data.body
        this.is_loading_current_province = "N"
      } else {

        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_current_province")
        this.is_loading_current_province = "N"
      }
    },
   async load_report_current_province_excel(){

      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      await axios({
          url: 'v1/organizer/report-runner-current-province-excel',
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())

          const excel_report_file_name = "[ข้อมูลจังหวัด]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          link.setAttribute('download', excel_report_file_name); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          //this.is_loading_order_excel_all = "N"
      });
      //this.is_loading_order_excel_all = "N"
    },
    async load_report_runner_regis_date_excel(){

      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      await axios({
          url: 'v1/organizer/report-runner-regis-date-excel',
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())

          const excel_report_file_name = "[ข้อมูลวันที่ลงทะเบียน]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          link.setAttribute('download', excel_report_file_name); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          //this.is_loading_order_excel_all = "N"
      });
      //this.is_loading_order_excel_all = "N"
    },
    async load_order_excel_self(){

      this.is_loading_order_excel_self = "Y"
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };

      await axios({
          url: 'v1/organizer/report-order-excel-self',
          method: 'POST',
          data: data,
          responseType: 'blob', 
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())
        

          const excel_report_file_name = "[REPORT-SELF]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          link.setAttribute('download', excel_report_file_name);
          link.click();
          URL.revokeObjectURL(href);
          this.is_loading_order_excel_self = "N"
      });
      this.is_loading_order_excel_self = "N"
    },
    async load_report_runner_tshirt_excel(){

      //this.is_loading_order_excel_all = "Y"
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      await axios({
          url: 'v1/organizer/report-runner-tshirt-excel',
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())

          const excel_report_file_name = "[จำนวนเสื้อ แต่ละขนาด]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          link.setAttribute('download', excel_report_file_name); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          //this.is_loading_order_excel_all = "N"
      });
      //this.is_loading_order_excel_all = "N"
    },
    async load_order_unpaid_excel(){

      //this.is_loading_order_excel_all = "Y"
      const data = {
        event_key: this.$route.params.event_key
      };
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      
      await axios({
          url: 'v1/organizer/report-order-unpaid',
          method: 'POST',
          data: data,
          responseType: 'blob',
          headers: headers
      }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          const dt = new Date();
          const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
          let txt_file = dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())

          const excel_report_file_name = "[คำสั่งซื้อ ที่รอชำระเงิน]"+this.$route.params.event_key+"-"+txt_file+".xlsx"
          link.setAttribute('download', excel_report_file_name); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          //this.is_loading_order_excel_all = "N"
      });
      //this.is_loading_order_excel_all = "N"
    },

    // Chart Methods
    createChart() {
      // Check if canvas ref exists
      if (!this.$refs.runnerTypeChart) {
        console.warn('Canvas ref not available yet');
        return;
      }

      if (this.runnerTypeChart) {
        this.runnerTypeChart.destroy();
        this.runnerTypeChart = null;
      }

      try {
        const ctx = this.$refs.runnerTypeChart.getContext('2d');
        
        const labels = this.report_runner_type.map(item => 
          item.run_type_name.replace(/<[^>]*>/g, '').trim()
        );
        const data = this.report_runner_type.map(item => parseInt(item.count_number));
        const colors = this.report_runner_type.map((_, index) => this.getChartColor(index));

        // เพิ่ม pixel ratio สำหรับความคมชัดสูงสุด
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 3); // จำกัดไม่เกิน 3 เพื่อ performance
        const canvasWidth = ctx.canvas.offsetWidth;
        const canvasHeight = ctx.canvas.offsetHeight;
        
        ctx.canvas.width = canvasWidth * pixelRatio;
        ctx.canvas.height = canvasHeight * pixelRatio;
        ctx.canvas.style.width = canvasWidth + 'px';
        ctx.canvas.style.height = canvasHeight + 'px';
        ctx.scale(pixelRatio, pixelRatio);
        
        // เพิ่ม antialiasing
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        this.runnerTypeChart = new ChartJS(ctx, {
          type: 'pie',
          data: {
            labels: labels,
            datasets: [{
              data: data,
              backgroundColor: colors,
              borderColor: '#ffffff',
              borderWidth: 4,
              hoverOffset: 20,
              hoverBorderWidth: 6,
              tension: 0.1
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            devicePixelRatio: pixelRatio,
            interaction: {
              intersect: false,
              mode: 'index'
            },
            plugins: {
              title: {
                display: true,
                text: 'จำนวนผู้สมัคร แต่ละประเภท',
                font: {
                  size: 20,
                  weight: 'bold',
                  family: '"Segoe UI", Arial, "Noto Sans Thai", sans-serif'
                },
                padding: 30,
                color: '#1a202c'
              },
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const label = context.label;
                    const value = context.parsed;
                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                    const percentage = ((value / total) * 100).toFixed(1);
                    return `${label}: ${value} คน (${percentage}%)`;
                  }
                },
                backgroundColor: 'rgba(26, 32, 44, 0.95)',
                titleColor: '#ffffff',
                bodyColor: '#ffffff',
                borderColor: 'rgba(255,255,255,0.3)',
                borderWidth: 2,
                cornerRadius: 12,
                titleFont: {
                  size: 16,
                  weight: 'bold',
                  family: '"Segoe UI", Arial, sans-serif'
                },
                bodyFont: {
                  size: 14,
                  family: '"Segoe UI", Arial, sans-serif'
                },
                padding: 16,
                displayColors: true,
                boxPadding: 8
              }
            },
            animation: {
              animateRotate: true,
              animateScale: true,
              duration: 1500,
              easing: 'easeOutQuart'
            },
            elements: {
              arc: {
                borderWidth: 4,
                borderColor: '#ffffff',
                hoverBorderWidth: 6,
                borderAlign: 'center'
              }
            },
            layout: {
              padding: {
                top: 10,
                bottom: 10,
                left: 10,
                right: 10
              }
            }
          }
        });
      } catch (error) {
        console.error('Error creating chart:', error);
      }
    },

    getChartColor(index) {
      return this.chartColors[index % this.chartColors.length];
    },

    getTotalRunners() {
      return this.report_runner_type.reduce((total, item) => {
        return total + parseInt(item.count_number);
      }, 0);
    },

    // ฟังก์ชันสำหรับกราฟแยกตามเพศ
    getTotalSexRunners() {
      return this.report_runner_type_sex.reduce((total, item) => {
        return total + parseInt(item.count_number);
      }, 0);
    },

    getSexChartData() {
      return this.report_runner_type_sex.map(item => ({
        label: `${item.run_type_name.replace(/<[^>]*>/g, '').trim()} (${item.sex})`,
        value: parseInt(item.count_number)
      }));
    },

    getSexChartColor(index) {
      return this.chartColors[index % this.chartColors.length];
    },

    getSexPercentage(count) {
      const total = this.getTotalSexRunners();
      if (total === 0) return 0;
      return ((parseInt(count) / total) * 100).toFixed(1);
    },

    createSexChart() {
      if (this.runnerTypeSexChart) {
        this.runnerTypeSexChart.destroy();
      }

      const ctx = this.$refs.runnerTypeSexChart.getContext('2d');
      const chartData = this.getSexChartData();
      
      // เพิ่ม pixel ratio สำหรับความคมชัดสูงสุด
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 3);
      const canvasWidth = ctx.canvas.offsetWidth;
      const canvasHeight = ctx.canvas.offsetHeight;
      
      ctx.canvas.width = canvasWidth * pixelRatio;
      ctx.canvas.height = canvasHeight * pixelRatio;
      ctx.canvas.style.width = canvasWidth + 'px';
      ctx.canvas.style.height = canvasHeight + 'px';
      ctx.scale(pixelRatio, pixelRatio);
      
      // เพิ่ม antialiasing
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      this.runnerTypeSexChart = new ChartJS(ctx, {
        type: 'pie',
        data: {
          labels: chartData.map(item => item.label),
          datasets: [{
            data: chartData.map(item => item.value),
            backgroundColor: chartData.map((_, index) => this.getSexChartColor(index)),
            borderColor: '#ffffff',
            borderWidth: 4,
            hoverOffset: 20,
            hoverBorderWidth: 6,
            tension: 0.1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          devicePixelRatio: pixelRatio,
          interaction: {
            intersect: false,
            mode: 'index'
          },
          plugins: {
            title: {
              display: true,
              text: 'จำนวนผู้สมัคร แต่ละประเภท แบงตามเพศ',
              font: {
                size: 20,
                weight: 'bold',
                family: '"Segoe UI", Arial, "Noto Sans Thai", sans-serif'
              },
              padding: 30,
              color: '#1a202c'
            },
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.parsed;
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = ((value / total) * 100).toFixed(1);
                  return `${label}: ${value} คน (${percentage}%)`;
                }
              },
              backgroundColor: 'rgba(26, 32, 44, 0.95)',
              titleColor: '#ffffff',
              bodyColor: '#ffffff',
              borderColor: 'rgba(255,255,255,0.3)',
              borderWidth: 2,
              cornerRadius: 12,
              titleFont: {
                size: 16,
                weight: 'bold',
                family: '"Segoe UI", Arial, sans-serif'
              },
              bodyFont: {
                size: 14,
                family: '"Segoe UI", Arial, sans-serif'
              },
              padding: 16,
              displayColors: true,
              boxPadding: 8
            }
          },
          animation: {
            animateRotate: true,
            animateScale: true,
            duration: 1500,
            easing: 'easeOutQuart'
          },
          elements: {
            arc: {
              borderWidth: 4,
              borderColor: '#ffffff',
              hoverBorderWidth: 6,
              borderAlign: 'center'
            }
          },
          layout: {
            padding: {
              top: 10,
              bottom: 10,
              left: 10,
              right: 10
            }
          }
        }
      });
    },

    getPercentage(count) {
      const total = this.getTotalRunners();
      if (total === 0) return 0;
      return ((parseInt(count) / total) * 100).toFixed(1);
    },

    // Export Chart as Image with High Quality
    exportChartAsImage() {
      if (!this.runnerTypeChart || this.report_runner_type.length === 0) {
        alert('ไม่พบข้อมูลกราฟที่จะ export');
        return;
      }

      try {
        // Create a high-resolution canvas for export
        const exportCanvas = document.createElement('canvas');
        const ctx = exportCanvas.getContext('2d');
        
        // Set high-resolution canvas size (2x for crisp image) - เพิ่มขนาด 20%
        const pixelRatio = 2; // Force 2x resolution for export
        const canvasWidth = 1440 * pixelRatio; // เพิ่มจาก 1200 เป็น 1440 (+20%)
        const canvasHeight = 720 * pixelRatio; // เพิ่มจาก 600 เป็น 720 (+20%)
        exportCanvas.width = canvasWidth;
        exportCanvas.height = canvasHeight;
        
        // Scale context for high resolution
        ctx.scale(pixelRatio, pixelRatio);
        
        // Enable high-quality rendering
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.textRenderingOptimization = 'optimizeQuality';
        
        // Fill white background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, 1440, 720); // ปรับขนาดตาม canvas ใหม่
        
        // Draw title with high-quality font
        ctx.fillStyle = '#1a202c';
        ctx.font = 'bold 38px "Segoe UI", Arial, "Noto Sans Thai", sans-serif'; // เพิ่มขนาดฟอนต์
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('จำนวนผู้สมัคร แต่ละประเภท', 720, 60); // ปรับตำแหน่งตามขนาดใหม่
        
        // Get original chart canvas and preserve aspect ratio
        const chartCanvas = this.$refs.runnerTypeChart;
        const originalWidth = chartCanvas.width;
        const originalHeight = chartCanvas.height;
        
        // Calculate chart position and size to maintain aspect ratio (เพิ่มขนาด 68% จากเดิม)
        const maxChartSize = 787; // เพิ่มจาก 562 เป็น 787 (+40% อีกครั้ง)
        const aspectRatio = originalWidth / originalHeight;
        let chartWidth, chartHeight;
        
        if (aspectRatio > 1) {
          chartWidth = maxChartSize;
          chartHeight = maxChartSize / aspectRatio;
        } else {
          chartHeight = maxChartSize;
          chartWidth = maxChartSize * aspectRatio;
        }
        
        const chartX = 36 + (maxChartSize - chartWidth) / 2; // ปรับตำแหน่งตามขนาดใหม่
        const chartY = 84 + (maxChartSize - chartHeight) / 2; // ปรับตำแหน่งตามขนาดใหม่
        
        // Draw chart maintaining original proportions
        ctx.drawImage(chartCanvas, chartX, chartY, chartWidth, chartHeight);
        
        // Draw legend on the right side
        const legendX = 696; // ปรับตำแหน่ง legend ตามขนาดใหม่ (580 * 1.2)
        let legendY = 144; // ปรับตำแหน่งตามขนาดใหม่ (120 * 1.2)
        
        // Legend title
        ctx.fillStyle = '#1a202c';
        ctx.font = 'bold 24px "Segoe UI", Arial, "Noto Sans Thai", sans-serif'; // เพิ่มขนาดฟอนต์
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText('รายละเอียด', legendX, legendY);
        legendY += 48; // เพิ่ม spacing
        
        // Legend items with high-quality rendering
        this.report_runner_type.forEach((item, index) => {
          const color = this.getChartColor(index);
          
          // Draw color circle with anti-aliasing
          ctx.fillStyle = color;
          ctx.beginPath();
          ctx.arc(legendX + 14, legendY, 12, 0, 2 * Math.PI); // เพิ่มขนาดวงกลม
          ctx.fill();
          
          // Add white border to circle
          ctx.strokeStyle = '#ffffff';
          ctx.lineWidth = 2;
          ctx.stroke();
          
          // Draw text with better typography
          ctx.fillStyle = '#1a202c';
          ctx.font = 'bold 22px "Segoe UI", Arial, "Noto Sans Thai", sans-serif'; // เพิ่มขนาดฟอนต์
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          
          // Clean HTML tags from run_type_name
          const cleanName = item.run_type_name.replace(/<[^>]*>/g, '').trim();
          ctx.fillText(cleanName, legendX + 42, legendY); // ปรับตำแหน่ง
          
          // Draw count with better styling
          ctx.fillStyle = '#4a5568';
          ctx.font = '19px "Segoe UI", Arial, "Noto Sans Thai", sans-serif'; // เพิ่มขนาดฟอนต์
          ctx.fillText(`${item.count_number} คน`, legendX + 42, legendY + 30); // ปรับตำแหน่ง
          
          legendY += 66; // เพิ่ม spacing
        });
        
        // Draw total summary with enhanced styling
        legendY += 30; // เพิ่ม spacing
        
        // Create gradient background for summary
        const gradient = ctx.createLinearGradient(legendX - 18, legendY - 24, legendX - 18, legendY + 42);
        gradient.addColorStop(0, '#f7fafc');
        gradient.addColorStop(1, '#edf2f7');
        ctx.fillStyle = gradient;
        ctx.fillRect(legendX - 18, legendY - 24, 336, 66); // เพิ่มขนาด 20%
        
        // Add border with shadow effect
        ctx.strokeStyle = '#cbd5e0';
        ctx.lineWidth = 2;
        ctx.strokeRect(legendX - 18, legendY - 24, 336, 66); // เพิ่มขนาด 20%
        
        // Add subtle shadow
        ctx.shadowColor = 'rgba(0,0,0,0.1)';
        ctx.shadowBlur = 4;
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 2;
        
        ctx.fillStyle = '#1a202c';
        ctx.font = 'bold 24px "Segoe UI", Arial, "Noto Sans Thai", sans-serif'; // เพิ่มขนาดฟอนต์
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(`รวมทั้งหมด: ${this.getTotalRunners()} คน`, legendX + 150, legendY + 8); // ปรับตำแหน่ง
        
        // Reset shadow
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        
        // Generate filename with timestamp
        const now = new Date();
        const timestamp = now.getFullYear() + 
                         String(now.getMonth() + 1).padStart(2, '0') + 
                         String(now.getDate()).padStart(2, '0') + '_' +
                         String(now.getHours()).padStart(2, '0') + 
                         String(now.getMinutes()).padStart(2, '0');
        
        const filename = `จำนวนผู้สมัครแต่ละประเภท_${this.$route.params.event_key}_${timestamp}.png`;
        
        // Convert to blob with high quality and download
        exportCanvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 'image/png', 1.0); // PNG format with maximum quality
        
      } catch (error) {
        console.error('Error exporting chart:', error);
        alert('เกิดข้อผิดพลาดในการ export รูปภาพ');
      }
    },

    // Export Sex Chart as Image with High Quality
    exportSexChartAsImage() {
      if (!this.runnerTypeSexChart || this.report_runner_type_sex.length === 0) {
        alert('ไม่พบข้อมูลกราฟที่จะ export');
        return;
      }

      try {
        // Create a high-resolution canvas for export
        const exportCanvas = document.createElement('canvas');
        const ctx = exportCanvas.getContext('2d');
        
        // Set high-resolution canvas size (2x for crisp image)
        const pixelRatio = 2; // Force 2x resolution for export
        const sexCanvasWidth = 1200 * pixelRatio;
        const sexCanvasHeight = 600 * pixelRatio;
        exportCanvas.width = sexCanvasWidth;
        exportCanvas.height = sexCanvasHeight;
        
        // Scale context for high resolution
        ctx.scale(pixelRatio, pixelRatio);
        
        // Enable high-quality rendering
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.textRenderingOptimization = 'optimizeQuality';
        
        // Fill white background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, 1200, 600);
        
        // Draw title with high-quality font
        ctx.fillStyle = '#1a202c';
        ctx.font = 'bold 32px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('จำนวนผู้สมัคร แต่ละประเภท แบงตามเพศ', 600, 50);
        
        // Get original chart canvas and preserve aspect ratio
        const chartCanvas = this.$refs.runnerTypeSexChart;
        const originalWidth = chartCanvas.width;
        const originalHeight = chartCanvas.height;
        
        // Calculate chart position and size to maintain aspect ratio
        const maxChartSize = 655; // เพิ่มจาก 468 เป็น 655 (+40%)
        const aspectRatio = originalWidth / originalHeight;
        let chartWidth, chartHeight;
        
        if (aspectRatio > 1) {
          chartWidth = maxChartSize;
          chartHeight = maxChartSize / aspectRatio;
        } else {
          chartHeight = maxChartSize;
          chartWidth = maxChartSize * aspectRatio;
        }
        
        const chartX = 30 + (maxChartSize - chartWidth) / 2;
        const chartY = 70 + (maxChartSize - chartHeight) / 2;
        
        // Draw chart maintaining original proportions
        ctx.drawImage(chartCanvas, chartX, chartY, chartWidth, chartHeight);
        
        // Draw legend on the right side with high-quality rendering
        const legendX = 580;
        let legendY = 120;
        
        // Legend title
        ctx.fillStyle = '#1a202c';
        ctx.font = 'bold 24px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText('รายละเอียด', legendX, legendY);
        legendY += 45;
        
        // Legend items with high-quality rendering
        this.getSexChartData().forEach((item, index) => {
          const color = this.getSexChartColor(index);
          
          // Draw color circle with anti-aliasing
          ctx.fillStyle = color;
          ctx.beginPath();
          ctx.arc(legendX + 12, legendY, 10, 0, 2 * Math.PI);
          ctx.fill();
          
          // Add white border to circle
          ctx.strokeStyle = '#ffffff';
          ctx.lineWidth = 2;
          ctx.stroke();
          
          // Draw text with better typography
          ctx.fillStyle = '#1a202c';
          ctx.font = 'bold 18px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          ctx.fillText(item.label, legendX + 35, legendY);
          
          // Draw count with better styling
          ctx.fillStyle = '#4a5568';
          ctx.font = '16px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
          ctx.fillText(`${item.value} คน`, legendX + 35, legendY + 25);
          
          legendY += 55;
        });
        
        // Draw total summary with enhanced styling
        legendY += 25;
        
        // Create gradient background for summary
        const gradient = ctx.createLinearGradient(legendX - 15, legendY - 20, legendX - 15, legendY + 35);
        gradient.addColorStop(0, '#f7fafc');
        gradient.addColorStop(1, '#edf2f7');
        ctx.fillStyle = gradient;
        ctx.fillRect(legendX - 15, legendY - 20, 280, 55);
        
        // Add border with shadow effect
        ctx.strokeStyle = '#cbd5e0';
        ctx.lineWidth = 2;
        ctx.strokeRect(legendX - 15, legendY - 20, 280, 55);
        
        // Add subtle shadow
        ctx.shadowColor = 'rgba(0,0,0,0.1)';
        ctx.shadowBlur = 4;
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 2;
        
        ctx.fillStyle = '#1a202c';
        ctx.font = 'bold 20px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(`รวมทั้งหมด: ${this.getTotalSexRunners()} คน`, legendX + 125, legendY + 7);
        
        // Reset shadow
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        
        // Generate filename with timestamp
        const now = new Date();
        const timestamp = now.getFullYear() + 
                         String(now.getMonth() + 1).padStart(2, '0') + 
                         String(now.getDate()).padStart(2, '0') + '_' +
                         String(now.getHours()).padStart(2, '0') + 
                         String(now.getMinutes()).padStart(2, '0');
        
        const filename = `จำนวนผู้สมัครแต่ละประเภทแบงตามเพศ_${this.$route.params.event_key}_${timestamp}.png`;
        
        // Convert to blob with high quality and download
        exportCanvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 'image/png', 1.0); // PNG format with maximum quality
        
      } catch (error) {
        console.error('Error exporting sex chart:', error);
        alert('เกิดข้อผิดพลาดในการ export รูปภาพ');
      }
    },

    // Order Chart Methods
    getTotalOrders() {
      return this.report_order_count.reduce((total, item) => {
        return total + parseInt(item.count_number);
      }, 0);
    },

    getOrderChartData() {
      return this.report_order_count.map(item => {
        let statusText = '';
        if (item.status === 'INITIAL') statusText = 'รอชำระเงิน';
        else if (item.status === 'PAID') statusText = 'ชำระเงินสำเร็จ';
        else if (item.status === 'CANCEL') statusText = 'ยกเลิก';
        
        return {
          label: statusText,
          value: parseInt(item.count_number),
          status: item.status
        };
      });
    },

    getOrderChartColor(index) {
      const orderSpecificColors = ['#dc3545', '#28a745', '#fd7e14']; // Red, Green, Orange
      return orderSpecificColors[index % orderSpecificColors.length];
    },

    getOrderPercentage(count) {
      const total = this.getTotalOrders();
      if (total === 0) return 0;
      return ((parseInt(count) / total) * 100).toFixed(1);
    },

    createOrderChart() {
      if (this.orderStatusChart) {
        this.orderStatusChart.destroy();
      }

      if (!this.$refs.orderStatusChart) {
        console.warn('Order chart canvas ref not available yet');
        return;
      }

      try {
        const ctx = this.$refs.orderStatusChart.getContext('2d');
        const chartData = this.getOrderChartData();
        
        // เพิ่ม pixel ratio สำหรับความคมชัดสูงสุด
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 3);
        const canvasWidth = ctx.canvas.offsetWidth;
        const canvasHeight = ctx.canvas.offsetHeight;
        
        ctx.canvas.width = canvasWidth * pixelRatio;
        ctx.canvas.height = canvasHeight * pixelRatio;
        ctx.canvas.style.width = canvasWidth + 'px';
        ctx.canvas.style.height = canvasHeight + 'px';
        ctx.scale(pixelRatio, pixelRatio);
        
        // เพิ่ม antialiasing
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        
        this.orderStatusChart = new ChartJS(ctx, {
          type: 'pie',
          data: {
            labels: chartData.map(item => item.label),
            datasets: [{
              data: chartData.map(item => item.value),
              backgroundColor: chartData.map((_, index) => this.getOrderChartColor(index)),
              borderColor: '#ffffff',
              borderWidth: 4,
              hoverOffset: 20,
              hoverBorderWidth: 6,
              tension: 0.1
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            devicePixelRatio: pixelRatio,
            interaction: {
              intersect: false,
              mode: 'index'
            },
            plugins: {
              title: {
                display: true,
                text: 'สถานะ คำสั่งซื้อ',
                font: {
                  size: 20,
                  weight: 'bold',
                  family: '"Segoe UI", Arial, "Noto Sans Thai", sans-serif'
                },
                padding: 30,
                color: '#1a202c'
              },
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const label = context.label || '';
                    const value = context.parsed;
                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                    const percentage = ((value / total) * 100).toFixed(1);
                    return `${label}: ${value} คำสั่ง (${percentage}%)`;
                  }
                },
                backgroundColor: 'rgba(26, 32, 44, 0.95)',
                titleColor: '#ffffff',
                bodyColor: '#ffffff',
                borderColor: 'rgba(255,255,255,0.3)',
                borderWidth: 2,
                cornerRadius: 12,
                titleFont: {
                  size: 16,
                  weight: 'bold',
                  family: '"Segoe UI", Arial, sans-serif'
                },
                bodyFont: {
                  size: 14,
                  family: '"Segoe UI", Arial, sans-serif'
                },
                padding: 16,
                displayColors: true,
                boxPadding: 8
              }
            },
            animation: {
              animateRotate: true,
              animateScale: true,
              duration: 1500,
              easing: 'easeOutQuart'
            },
            elements: {
              arc: {
                borderWidth: 4,
                borderColor: '#ffffff',
                hoverBorderWidth: 6,
                borderAlign: 'center'
              }
            },
            layout: {
              padding: {
                top: 10,
                bottom: 10,
                left: 10,
                right: 10
              }
            }
          }
        });
      } catch (error) {
        console.error('Error creating order chart:', error);
      }
    },

    // Export Order Chart as Image with High Quality
    exportOrderChartAsImage() {
      if (!this.orderStatusChart || this.report_order_count.length === 0) {
        alert('ไม่พบข้อมูลกราฟที่จะ export');
        return;
      }

      try {
        // Create a high-resolution canvas for export
        const exportCanvas = document.createElement('canvas');
        const ctx = exportCanvas.getContext('2d');
        
        // Set high-resolution canvas size (2x for crisp image)
        const pixelRatio = 2;
        const orderCanvasWidth = 1200 * pixelRatio;
        const orderCanvasHeight = 600 * pixelRatio;
        exportCanvas.width = orderCanvasWidth;
        exportCanvas.height = orderCanvasHeight;
        
        // Scale context for high resolution
        ctx.scale(pixelRatio, pixelRatio);
        
        // Enable high-quality rendering
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.textRenderingOptimization = 'optimizeQuality';
        
        // Fill white background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, 1200, 600);
        
        // Draw title with high-quality font
        ctx.fillStyle = '#1a202c';
        ctx.font = 'bold 32px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('สถานะ คำสั่งซื้อ', 600, 50);
        
        // Get original chart canvas and preserve aspect ratio
        const chartCanvas = this.$refs.orderStatusChart;
        const originalWidth = chartCanvas.width;
        const originalHeight = chartCanvas.height;
        
        // Calculate chart position and size to maintain aspect ratio
        const maxChartSize = 655; // เพิ่มจาก 468 เป็น 655 (+40%)
        const aspectRatio = originalWidth / originalHeight;
        let chartWidth, chartHeight;
        
        if (aspectRatio > 1) {
          chartWidth = maxChartSize;
          chartHeight = maxChartSize / aspectRatio;
        } else {
          chartHeight = maxChartSize;
          chartWidth = maxChartSize * aspectRatio;
        }
        
        const chartX = 30 + (maxChartSize - chartWidth) / 2;
        const chartY = 70 + (maxChartSize - chartHeight) / 2;
        
        // Draw chart maintaining original proportions
        ctx.drawImage(chartCanvas, chartX, chartY, chartWidth, chartHeight);
        
        // Draw legend on the right side
        const legendX = 580;
        let legendY = 120;
        
        // Legend title
        ctx.fillStyle = '#333';
        ctx.font = 'bold 20px "Segoe UI", Arial, sans-serif';
        ctx.textAlign = 'left';
        ctx.fillText('รายละเอียด', legendX, legendY);
        legendY += 40;
        
        // Legend items with high-quality rendering
        this.getOrderChartData().forEach((item, index) => {
          const color = this.getOrderChartColor(index);
          
          // Draw color circle with anti-aliasing
          ctx.fillStyle = color;
          ctx.beginPath();
          ctx.arc(legendX + 12, legendY, 10, 0, 2 * Math.PI);
          ctx.fill();
          
          // Add white border to circle
          ctx.strokeStyle = '#ffffff';
          ctx.lineWidth = 2;
          ctx.stroke();
          
          // Draw text with better typography
          ctx.fillStyle = '#1a202c';
          ctx.font = 'bold 18px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          ctx.fillText(item.label, legendX + 35, legendY);
          
          // Draw count with better styling
          ctx.fillStyle = '#4a5568';
          ctx.font = '16px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
          ctx.fillText(`${item.value} คำสั่ง`, legendX + 35, legendY + 25);
          
          legendY += 55;
        });
        
        // Draw total summary with enhanced styling
        legendY += 25;
        
        // Create gradient background for summary
        const gradient = ctx.createLinearGradient(legendX - 15, legendY - 20, legendX - 15, legendY + 35);
        gradient.addColorStop(0, '#f7fafc');
        gradient.addColorStop(1, '#edf2f7');
        ctx.fillStyle = gradient;
        ctx.fillRect(legendX - 15, legendY - 20, 280, 55);
        
        // Add border with shadow effect
        ctx.strokeStyle = '#cbd5e0';
        ctx.lineWidth = 2;
        ctx.strokeRect(legendX - 15, legendY - 20, 280, 55);
        
        // Add subtle shadow
        ctx.shadowColor = 'rgba(0,0,0,0.1)';
        ctx.shadowBlur = 4;
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 2;
        
        ctx.fillStyle = '#1a202c';
        ctx.font = 'bold 20px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(`รวมทั้งหมด: ${this.getTotalOrders()} คำสั่ง`, legendX + 125, legendY + 7);
        
        // Reset shadow
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        
        // Generate filename with timestamp
        const now = new Date();
        const timestamp = now.getFullYear() + 
                         String(now.getMonth() + 1).padStart(2, '0') + 
                         String(now.getDate()).padStart(2, '0') + '_' +
                         String(now.getHours()).padStart(2, '0') + 
                         String(now.getMinutes()).padStart(2, '0');
        
        const filename = `สถานะคำสั่งซื้อ_${this.$route.params.event_key}_${timestamp}.png`;
        
        // Convert to blob with high quality and download
        exportCanvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 'image/png', 1.0); // PNG format with maximum quality
        
      } catch (error) {
        console.error('Error exporting order chart:', error);
        alert('เกิดข้อผิดพลาดในการ export รูปภาพ');
      }
    },
    
    createProvinceChart() {
      if (this.provinceChart) {
        this.provinceChart.destroy();
      }
      
      const canvas = this.$refs.provinceChart;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      
      // Prepare data - sort by count descending
      const sortedData = [...this.report_current_province]
        .sort((a, b) => b.count_number - a.count_number);
      
      const labels = sortedData.map(item => this.stripHtml(item.current_province) || 'ไม่ระบุ');
      const data = sortedData.map(item => item.count_number);
      
      this.provinceChart = new ChartJS(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: 'จำนวนผู้สมัคร',
            data: data,
            backgroundColor: this.chartColors,
            borderColor: this.chartColors.map(color => color),
            borderWidth: 1
          }]
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return 'จำนวน: ' + context.parsed.x + ' คน';
                }
              }
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                precision: 0
              }
            },
            y: {
              ticks: {
                font: {
                  size: 11
                }
              }
            }
          }
        },
        plugins: [{
          id: 'dataLabels',
          afterDatasetsDraw: function(chart) {
            const ctx = chart.ctx;
            chart.data.datasets.forEach(function(dataset, i) {
              const meta = chart.getDatasetMeta(i);
              if (!meta.hidden) {
                meta.data.forEach(function(element, index) {
                  ctx.fillStyle = '#1a202c';
                  ctx.font = 'bold 12px Arial, "Noto Sans Thai"';
                  ctx.textAlign = 'left';
                  ctx.textBaseline = 'middle';
                  
                  const dataString = dataset.data[index].toString() + ' คน';
                  const position = element.tooltipPosition();
                  
                  // Add small padding from the end of bar
                  ctx.fillText(dataString, position.x + 5, position.y);
                });
              }
            });
          }
        }]
      });
    },
    
    exportProvinceChartAsImage() {
      if (!this.provinceChart) {
        alert('ไม่พบกราฟที่จะ export');
        return;
      }
      
      try {
        // Create a temporary canvas for export with better quality
        const tempCanvas = document.createElement('canvas');
        const scale = 2; // Higher resolution for better quality
        
        // Calculate proper height for 20 provinces - adjusted to show all bars
        const chartWidth = 1400;  // Optimal width for horizontal bar chart
        const chartHeight = 1200;  // Increased height to ensure all 20 bars are fully visible with spacing
        
        // Set canvas size with scale
        tempCanvas.width = chartWidth * scale;
        tempCanvas.height = chartHeight * scale;
        
        const tempCtx = tempCanvas.getContext('2d');
        tempCtx.scale(scale, scale);
        
        // Create a temporary chart instance for export
        const sortedData = [...this.report_current_province]
          .sort((a, b) => b.count_number - a.count_number)
          .slice(0, 20);
        
        const labels = sortedData.map(item => this.stripHtml(item.current_province) || 'ไม่ระบุ');
        const data = sortedData.map(item => item.count_number);
        
        const tempChart = new ChartJS(tempCtx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'จำนวนผู้สมัคร',
              data: data,
              backgroundColor: this.chartColors,
              borderColor: this.chartColors.map(color => color),
              borderWidth: 1,
              barThickness: 30,  // Control bar thickness
              categoryPercentage: 0.95,
              barPercentage: 0.9
            }]
          },
          options: {
            indexAxis: 'y',
            responsive: false,
            maintainAspectRatio: false,
            animation: false,
            plugins: {
              legend: {
                display: false
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                grid: {
                  display: true,
                  color: 'rgba(0, 0, 0, 0.05)'
                },
                ticks: {
                  precision: 0,
                  font: {
                    size: 10
                  }
                }
              },
              y: {
                grid: {
                  display: false
                },
                ticks: {
                  font: {
                    size: 10
                  }
                }
              }
            }
          },
          plugins: [{
            id: 'dataLabels',
            afterDatasetsDraw: function(chart) {
              const ctx = chart.ctx;
              chart.data.datasets.forEach(function(dataset, i) {
                const meta = chart.getDatasetMeta(i);
                if (!meta.hidden) {
                  meta.data.forEach(function(element, index) {
                    ctx.fillStyle = '#1a202c';
                    ctx.font = 'bold 10px Arial, "Noto Sans Thai"';
                    ctx.textAlign = 'left';
                    ctx.textBaseline = 'middle';
                    
                    const dataString = dataset.data[index].toString() + ' คน';
                    const position = element.tooltipPosition();
                    
                    ctx.fillText(dataString, position.x + 5, position.y);
                  });
                }
              });
            }
          }]
        });
        
        // Wait for chart to be fully rendered
        setTimeout(() => {
          // Create final export canvas with minimal padding
          const exportCanvas = document.createElement('canvas');
          const padding = 20;
          const bottomSpace = 60; // Space for bottom text
          
          exportCanvas.width = tempCanvas.width + (padding * 2 * scale);
          exportCanvas.height = tempCanvas.height + (padding * scale) + (bottomSpace * scale);
          
          const ctx = exportCanvas.getContext('2d');
          ctx.scale(scale, scale);
          
          // Draw background
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, exportCanvas.width / scale, exportCanvas.height / scale);
          
          // Draw the chart (no title at top)
          ctx.drawImage(tempCanvas, padding, padding);
          
          // Draw bottom text
          const bottomTextY = (tempCanvas.height / scale) + padding + 35;
          
          ctx.fillStyle = '#495057';
          ctx.font = '14px "Segoe UI", Arial, "Noto Sans Thai", sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(`แสดง Top 20 จังหวัดที่มีผู้สมัครมากที่สุด`, exportCanvas.width / scale / 2, bottomTextY);
          
          // Generate filename
          const now = new Date();
          const timestamp = now.getFullYear() + 
                           String(now.getMonth() + 1).padStart(2, '0') + 
                           String(now.getDate()).padStart(2, '0') + '_' +
                           String(now.getHours()).padStart(2, '0') + 
                           String(now.getMinutes()).padStart(2, '0');
          
          const filename = `ข้อมูลจังหวัด_${this.$route.params.event_key}_${timestamp}.png`;
          
          // Convert to blob and download
          exportCanvas.toBlob((blob) => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            
            // Cleanup
            tempChart.destroy();
          }, 'image/png', 1.0);
        }, 100);
        
      } catch (error) {
        console.error('Error exporting province chart:', error);
        alert('เกิดข้อผิดพลาดในการ export รูปภาพ');
      }
    },
    
    getTotalProvinces() {
      return this.report_current_province.reduce((sum, item) => sum + parseInt(item.count_number), 0);
    },
    
    getProvincePercentage(count) {
      const total = this.getTotalProvinces();
      if (total === 0) return '0.0';
      return ((count / total) * 100).toFixed(1);
    },
    
    stripHtml(html) {
      if (!html) return '';
      const tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    },
    
    // Registration Date Chart Methods
    getTotalRegisDate() {
      return this.report_regis_date.reduce((sum, item) => sum + parseInt(item.count_number), 0);
    },
    
    getRegisDatePercentage(count) {
      const total = this.getTotalRegisDate();
      if (total === 0) return '0.0';
      return ((count / total) * 100).toFixed(1);
    },
    
    createRegisDateChart() {
      if (this.regisDateChart) {
        this.regisDateChart.destroy();
      }
      
      const canvas = this.$refs.regisDateChart;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      
      // Show all data in chronological order (no sorting, no limiting)
      const labels = this.report_regis_date.map(item => this.stripHtml(item.regis_date) || 'ไม่ระบุ');
      const data = this.report_regis_date.map(item => item.count_number);
      
      this.regisDateChart = new ChartJS(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: 'จำนวนผู้ลงทะเบียน',
            data: data,
            backgroundColor: this.chartColors,
            borderColor: this.chartColors.map(color => color),
            borderWidth: 1,
            barThickness: 15,
            categoryPercentage: 0.8,
            barPercentage: 0.7
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return 'จำนวน: ' + context.parsed.y + ' คน';
                }
              }
            }
          },
          scales: {
            x: {
              ticks: {
                font: {
                  size: 11
                },
                maxRotation: 45,
                minRotation: 45
              }
            },
            y: {
              beginAtZero: true,
              ticks: {
                precision: 0
              }
            }
          }
        },
        plugins: [{
          id: 'dataLabels',
          afterDatasetsDraw: function(chart) {
            const ctx = chart.ctx;
            chart.data.datasets.forEach(function(dataset, i) {
              const meta = chart.getDatasetMeta(i);
              if (!meta.hidden) {
                meta.data.forEach(function(element, index) {
                  ctx.fillStyle = '#1a202c';
                  ctx.font = 'bold 12px Arial, "Noto Sans Thai"';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'bottom';
                  
                  const dataString = dataset.data[index].toString();
                  const position = element.tooltipPosition();
                  
                  // Place text on top of the bar
                  ctx.fillText(dataString, position.x, element.y - 5);
                });
              }
            });
          }
        }]
      });
    }
  }
};
</script>

<style scoped>
/* Chart Styles */
.chart-container {
  position: relative;
  padding: 5px 10px;
  margin: 0;
}

.chart-legend {
  max-height: 400px;
  overflow-y: auto;
  padding: 15px 10px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 0;
}

.legend-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.legend-item:last-child {
  border-bottom: none;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.legend-text {
  flex: 1;
}

.legend-name {
  font-weight: 500;
  color: #495057;
  font-size: 14px;
  line-height: 1.4;
}

.legend-count {
  color: #6c757d;
  font-size: 12px;
  margin-top: 2px;
}

.total-summary {
  text-align: center;
  color: #495057;
  font-size: 16px;
  padding: 8px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.chart-color-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  display: inline-block;
  flex-shrink: 0;
}

/* Modern Button Styles */
.btn-outline-primary {
  transition: all 0.3s ease;
}

.btn-outline-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,123,255,0.3);
}

.btn-success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  transition: all 0.3s ease;
}

.btn-success:hover {
  background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.btn-success:disabled {
  background: #6c757d !important;
  border-color: #6c757d !important;
  transform: none;
  box-shadow: none;
  cursor: not-allowed;
}

/* Export Card Styles */
.export-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
  height: 100%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.06);
}

.export-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  border-color: #dee2e6;
}

.export-card-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  color: white;
}

.export-card-content {
  text-align: center;
}

.export-card-title {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
  line-height: 1.3;
}

.export-card-desc {
  font-size: 13px;
  color: #718096;
  margin-bottom: 15px;
  line-height: 1.4;
}

/* Export List Styles */
.export-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.export-list-item {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.export-list-item:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  transform: translateX(5px);
}

.export-list-icon {
  width: 50px;
  height: 50px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  flex-shrink: 0;
}

.export-list-content {
  flex: 1;
}

.export-list-title {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 5px;
}

.export-list-desc {
  font-size: 14px;
  color: #718096;
  margin-bottom: 0;
  line-height: 1.4;
}

.export-list-action {
  margin-left: 15px;
}

.export-run-type-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.export-run-type-item .btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 5px;
  font-size: 12px;
}

/* Table Enhancements */
.table-info {
  background-color: #e3f2fd !important;
}

.table th {
  background-color: #f8f9fa;
  border-top: none;
  font-weight: 600;
  color: #495057;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0,0,0,.02);
}

/* Loading Animation */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.chart-loading {
  animation: pulse 1.5s infinite;
}

/* View Toggle Switch Styles */
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-label {
  font-weight: 500;
  color: #495057;
}

.gap-3 {
  gap: 1rem !important;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .chart-container {
    height: 300px !important;
  }
  
  .chart-legend {
    margin-top: 20px;
    max-height: 200px;
  }
  
  .legend-name {
    font-size: 13px;
  }
  
  .header-top {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .d-flex.gap-3 {
    flex-wrap: wrap;
    margin-top: 10px;
  }
}
</style>
